"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f99 = void 0;
exports.f99 = {
    "cm": [
        19,
        33,
        89,
        122,
        166,
        168,
        251,
        339,
        469,
        477,
        498,
        606,
        614,
        615,
        626,
        628,
        629,
        630,
        631,
        642,
        643,
        644,
        650,
        656,
        657,
        658,
        664,
        682,
        698,
        705,
        716,
        717,
        745,
        752,
        755,
        758,
        784,
        787,
        827,
        855,
        880,
        887,
        891,
        896,
        898,
        958,
        965,
        996,
        1004,
        1053,
        1062,
        1064,
        1069,
        1075,
        1087,
        1119,
        1123,
        1135,
        1145,
        1146,
        1183,
        1202,
        1208,
        1229,
        1242,
        1264,
        1266,
        1272,
        1292,
        1318,
        1511,
        1683,
        1695,
        1725,
        1761,
        1800,
        1852,
        1891,
        1900,
        1905,
        1906,
        1949,
        1995,
        2011,
        2018,
        2084,
        2108,
        2117,
        2139,
        2308,
        2323,
        2339,
        2340,
        2355,
        2367,
        2399,
        2403,
        2431,
        2479,
        2480,
        2641,
        2652,
        2658,
        2669,
        2694,
        2695,
        2707,
        2748,
        2863,
        2877,
        2946,
        2999,
        3106,
        3259,
        3297,
        3334,
        3359,
        3362,
        3371,
        3557,
        3571,
        3603,
        3605,
        3674,
        3745,
        3766,
        3797,
        3808,
        3835,
        3867,
        3921,
        3959,
        4054,
        4057,
        4092,
        4177,
        4225,
        4277,
        4279,
        4293,
        4410,
        4416,
        4435,
        4539,
        4575,
        4613,
        4640,
        4643,
        4644,
        4645,
        4654,
        4680,
        4697,
        4711,
        4713,
        4716,
        4717,
        4718,
        4719,
        4720,
        4746,
        4754,
        4776,
        4797,
        4801,
        4856,
        4876,
        4892,
        4896,
        4920,
        4940,
        4992,
        5011,
        5061,
        5093,
        5111,
        5126,
        5128,
        5131,
        5138,
        5147,
        5210,
        5225,
        5237,
        5260,
        5330,
        5351,
        5360,
        5378,
        5419,
        5425,
        5429,
        5433,
        5440,
        5443,
        5462,
        5498,
        5508,
        5513,
        5544,
        5567,
        5573,
        5581,
        5599,
        5616,
        5688,
        5755,
        5763,
        5812,
        5828,
        5887,
        5977,
        6011,
        6049,
        6109,
        6213,
        6214,
        6248,
        6815,
        7046,
        7244,
        7293,
        7505,
        7659,
        7736,
        7760,
        7791,
        7814,
        7829,
        7910,
        7929,
        8018,
        8145,
        8206,
        8212,
        8314,
        8379,
        8451,
        8531,
        8533,
        8536,
        8537,
        8539,
        8731,
        8738,
        8739,
        8741,
        8747,
        8772,
        8822,
        9049,
        9178
    ],
    "cameroon": [
        1145,
        4645,
        8212,
        498,
        626,
        855,
        887,
        896,
        1146,
        1183,
        2308,
        2339,
        2999,
        3371,
        4279,
        4539,
        4613,
        5061,
        5225,
        8738,
        19,
        33,
        89,
        122,
        166,
        168,
        251,
        339,
        469,
        477,
        606,
        614,
        615,
        628,
        629,
        630,
        631,
        642,
        643,
        644,
        650,
        656,
        657,
        658,
        664,
        682,
        698,
        705,
        716,
        717,
        745,
        752,
        755,
        758,
        784,
        787,
        827,
        880,
        891,
        898,
        958,
        965,
        996,
        1004,
        1053,
        1062,
        1064,
        1069,
        1075,
        1087,
        1119,
        1123,
        1135,
        1202,
        1208,
        1229,
        1242,
        1264,
        1266,
        1272,
        1292,
        1318,
        1511,
        1683,
        1695,
        1725,
        1761,
        1800,
        1852,
        1891,
        1900,
        1905,
        1906,
        1949,
        1995,
        2011,
        2018,
        2084,
        2108,
        2117,
        2139,
        2323,
        2340,
        2355,
        2367,
        2399,
        2403,
        2431,
        2479,
        2480,
        2641,
        2652,
        2658,
        2669,
        2694,
        2695,
        2707,
        2748,
        2863,
        2877,
        2946,
        3106,
        3259,
        3297,
        3334,
        3359,
        3362,
        3557,
        3571,
        3603,
        3605,
        3674,
        3745,
        3766,
        3797,
        3808,
        3835,
        3867,
        3921,
        3959,
        4054,
        4057,
        4092,
        4177,
        4225,
        4277,
        4293,
        4410,
        4416,
        4435,
        4575,
        4640,
        4643,
        4644,
        4654,
        4680,
        4697,
        4711,
        4713,
        4716,
        4717,
        4718,
        4719,
        4720,
        4746,
        4754,
        4776,
        4797,
        4801,
        4856,
        4876,
        4892,
        4896,
        4920,
        4940,
        4992,
        5011,
        5093,
        5111,
        5126,
        5128,
        5131,
        5138,
        5147,
        5210,
        5237,
        5260,
        5330,
        5351,
        5360,
        5378,
        5419,
        5425,
        5429,
        5433,
        5440,
        5443,
        5462,
        5498,
        5508,
        5513,
        5544,
        5567,
        5573,
        5581,
        5599,
        5616,
        5688,
        5755,
        5763,
        5812,
        5828,
        5887,
        5977,
        6011,
        6049,
        6109,
        6213,
        6214,
        6248,
        6815,
        7046,
        7244,
        7293,
        7505,
        7659,
        7736,
        7760,
        7791,
        7814,
        7829,
        7910,
        7929,
        8018,
        8145,
        8206,
        8314,
        8379,
        8451,
        8531,
        8533,
        8536,
        8537,
        8539,
        8731,
        8739,
        8741,
        8747,
        8772,
        8822,
        9049,
        9178
    ],
    "ci": [
        1465,
        32,
        40,
        54,
        96,
        180,
        187,
        190,
        259,
        342,
        492,
        535,
        668,
        733,
        735,
        882,
        1071,
        1150,
        1741,
        1847,
        1919,
        2035,
        2041,
        2042,
        2055,
        2067,
        2244,
        2293,
        2430,
        2625,
        2642,
        2712,
        2723,
        2726,
        2806,
        2841,
        2857,
        3101,
        3349,
        3411,
        3429,
        3606,
        3621,
        3910,
        3991,
        4088,
        4099,
        4137,
        4164,
        4252,
        4447,
        4457,
        4847,
        4960,
        5102,
        5228,
        5390,
        5413,
        5446,
        5531,
        5757,
        6196,
        6384,
        6775,
        6779,
        6795,
        7412,
        7464,
        7526,
        8161,
        8203,
        8305,
        8462,
        8894
    ],
    "côte d'ivoire": [
        32,
        40,
        54,
        96,
        180,
        187,
        190,
        259,
        342,
        492,
        535,
        668,
        733,
        735,
        882,
        1071,
        1150,
        1741,
        1847,
        1919,
        2035,
        2041,
        2042,
        2055,
        2067,
        2244,
        2293,
        2430,
        2625,
        2642,
        2712,
        2723,
        2726,
        2806,
        2841,
        2857,
        3101,
        3349,
        3411,
        3429,
        3606,
        3621,
        3910,
        3991,
        4088,
        4099,
        4137,
        4164,
        4252,
        4447,
        4457,
        4847,
        4960,
        5102,
        5228,
        5390,
        5413,
        5446,
        5531,
        5757,
        6196,
        6384,
        6775,
        6779,
        6795,
        7412,
        7464,
        7526,
        8161,
        8203,
        8305,
        8462,
        8894
    ],
    "côte": [
        463,
        464,
        2244,
        3606,
        4447,
        5390,
        32,
        40,
        54,
        96,
        180,
        187,
        190,
        259,
        342,
        492,
        535,
        668,
        733,
        735,
        882,
        1071,
        1150,
        1741,
        1847,
        1919,
        2035,
        2041,
        2042,
        2055,
        2067,
        2293,
        2430,
        2625,
        2642,
        2712,
        2723,
        2726,
        2806,
        2841,
        2857,
        3101,
        3349,
        3411,
        3429,
        3621,
        3910,
        3991,
        4088,
        4099,
        4137,
        4164,
        4252,
        4457,
        4847,
        4960,
        5102,
        5228,
        5413,
        5446,
        5531,
        5757,
        6196,
        6384,
        6775,
        6779,
        6795,
        7412,
        7464,
        7526,
        8161,
        8203,
        8305,
        8462,
        8894
    ],
    "camarinas norte agta": [
        35
    ],
    "camarinas": [
        35
    ],
    "ca": [
        321,
        2006,
        2469,
        2692,
        2731,
        6101,
        3981,
        4127,
        7605,
        36,
        273,
        461,
        493,
        677,
        714,
        715,
        911,
        912,
        914,
        1175,
        1333,
        1334,
        1350,
        1452,
        1453,
        1515,
        1573,
        1596,
        1597,
        1608,
        1609,
        1610,
        1611,
        1612,
        1613,
        1614,
        1623,
        1624,
        1652,
        1802,
        1804,
        1805,
        1826,
        1982,
        2135,
        2350,
        2425,
        2603,
        2653,
        2848,
        2890,
        2905,
        2908,
        2926,
        3087,
        3185,
        3186,
        3187,
        3281,
        3282,
        3762,
        4034,
        4083,
        4335,
        4336,
        4793,
        4794,
        4963,
        4965,
        5340,
        5690,
        5691,
        5699,
        5734,
        5859,
        5860,
        5861,
        5862,
        5863,
        5865,
        5866,
        5868,
        5869,
        5870,
        5871,
        5922,
        5928,
        5994,
        6086,
        6281,
        6352,
        6734,
        6735,
        6776,
        6784,
        6785,
        6853,
        7086,
        7118,
        7172,
        7175,
        7359,
        7465,
        7479,
        7480,
        7484,
        7737,
        7767,
        7798
    ],
    "canada": [
        3186,
        3187,
        36,
        273,
        461,
        493,
        677,
        714,
        715,
        911,
        912,
        914,
        1175,
        1333,
        1334,
        1350,
        1452,
        1453,
        1515,
        1573,
        1596,
        1597,
        1608,
        1609,
        1610,
        1611,
        1612,
        1613,
        1614,
        1623,
        1624,
        1652,
        1802,
        1804,
        1805,
        1826,
        1982,
        2135,
        2350,
        2425,
        2603,
        2653,
        2848,
        2890,
        2905,
        2908,
        2926,
        3087,
        3185,
        3281,
        3282,
        3762,
        4034,
        4083,
        4335,
        4336,
        4793,
        4794,
        4963,
        4965,
        5340,
        5690,
        5691,
        5699,
        5734,
        5859,
        5860,
        5861,
        5862,
        5863,
        5865,
        5866,
        5868,
        5869,
        5870,
        5871,
        5922,
        5928,
        5994,
        6086,
        6281,
        6352,
        6734,
        6735,
        6776,
        6784,
        6785,
        6853,
        7086,
        7118,
        7172,
        7175,
        7359,
        7465,
        7479,
        7480,
        7484,
        7737,
        7767,
        7798
    ],
    "central asian": [
        39
    ],
    "central": [
        169,
        560,
        649,
        660,
        661,
        997,
        999,
        1000,
        1001,
        1496,
        1497,
        1498,
        1535,
        1536,
        1537,
        1554,
        1642,
        1846,
        2299,
        2539,
        2540,
        2782,
        2972,
        2984,
        4431,
        4599,
        4690,
        5060,
        5187,
        5230,
        5334,
        5335,
        5341,
        5356,
        5403,
        5456,
        5863,
        6056,
        6184,
        6259,
        6311,
        6323,
        6648,
        6972,
        7267,
        7318,
        7461,
        7471,
        7788,
        7884,
        7885,
        7886,
        8952,
        8997,
        9004,
        39,
        384,
        531,
        733,
        863,
        1075,
        1304,
        1329,
        1623,
        1624,
        1717,
        1925,
        1989,
        2054,
        2084,
        2297,
        2298,
        2857,
        2971,
        2986,
        2989,
        2991,
        3090,
        3145,
        3394,
        3400,
        3791,
        3824,
        3832,
        3833,
        3861,
        3925,
        3926,
        4108,
        4314,
        4341,
        4342,
        4380,
        4471,
        4472,
        4800,
        4804,
        4920,
        4926,
        4927,
        4929,
        4931,
        4932,
        5183,
        5188,
        5629,
        5819,
        6383,
        6394,
        6398,
        6401,
        6487,
        6542,
        6718,
        6737,
        6786,
        7139,
        7468,
        7469,
        7738,
        7835,
        8106,
        8123,
        8124,
        8194,
        8580,
        8648,
        8741,
        8761,
        8988,
        9145,
        568,
        572,
        843,
        844,
        874,
        975,
        1023,
        1555,
        1669,
        1682,
        1702,
        1807,
        3151,
        3173,
        3466,
        3490,
        3518,
        4792,
        4815,
        5124,
        5157,
        5220,
        5221,
        5224,
        5267,
        5424,
        5571,
        5900,
        5902,
        6249,
        7167,
        7360,
        7576,
        8664,
        8991,
        9116,
        9135,
        219,
        704,
        747,
        754,
        890,
        893,
        948,
        1028,
        1060,
        1212,
        1821,
        2427,
        2545,
        2555,
        2556,
        2560,
        2583,
        2608,
        2722,
        2792,
        2862,
        3969,
        4037,
        4144,
        4347,
        4421,
        4423,
        4648,
        4665,
        4753,
        5277,
        5320,
        5382,
        5426,
        5816,
        6717,
        6804,
        6999,
        7078,
        7934,
        8046,
        8727,
        8826,
        8932
    ],
    "capuleño": [
        57
    ],
    "co": [
        5384,
        3886,
        6017,
        6018,
        6019,
        60,
        315,
        329,
        334,
        351,
        441,
        623,
        687,
        961,
        1027,
        1129,
        1352,
        1353,
        1354,
        1355,
        1368,
        1370,
        1371,
        1438,
        1532,
        1564,
        1602,
        1643,
        1668,
        1681,
        1685,
        2264,
        2724,
        2805,
        2809,
        2814,
        2816,
        3066,
        3130,
        3213,
        3218,
        3484,
        3856,
        3875,
        4058,
        4081,
        4612,
        4614,
        4616,
        4636,
        4976,
        5253,
        5618,
        5627,
        6043,
        6151,
        6155,
        6192,
        6305,
        6361,
        6889,
        6941,
        7004,
        7109,
        7321,
        7342,
        7385,
        7420,
        7513,
        7616,
        7617,
        7618,
        7765,
        7787,
        7788,
        8762,
        8868,
        8929,
        8935
    ],
    "colombia": [
        4058,
        7420,
        60,
        315,
        329,
        334,
        351,
        441,
        623,
        687,
        961,
        1027,
        1129,
        1352,
        1353,
        1354,
        1355,
        1368,
        1370,
        1371,
        1438,
        1532,
        1564,
        1602,
        1643,
        1668,
        1681,
        1685,
        2264,
        2724,
        2805,
        2809,
        2814,
        2816,
        3066,
        3130,
        3213,
        3218,
        3484,
        3856,
        3875,
        4081,
        4612,
        4614,
        4616,
        4636,
        4976,
        5253,
        5618,
        5627,
        6043,
        6151,
        6155,
        6192,
        6305,
        6361,
        6889,
        6941,
        7004,
        7109,
        7321,
        7342,
        7385,
        7513,
        7616,
        7617,
        7618,
        7765,
        7787,
        7788,
        8762,
        8868,
        8929,
        8935
    ],
    "chode": [
        62
    ],
    "creole": [
        65,
        146,
        200,
        616,
        659,
        1081,
        1306,
        1307,
        1373,
        1379,
        1619,
        2568,
        2569,
        2571,
        2813,
        2866,
        2916,
        3064,
        3130,
        3315,
        3813,
        4461,
        4637,
        5432,
        6264,
        6490,
        6722,
        6725,
        6935,
        7217,
        7362,
        7371,
        7452,
        7705,
        8081,
        8097,
        8098,
        3934,
        877,
        1035,
        1770,
        1878,
        1879,
        2416,
        3102,
        3558,
        4712,
        5274,
        5288,
        6077,
        6111,
        6592,
        7113,
        7817,
        7953,
        8212
    ],
    "créole": [
        65,
        3064,
        4461,
        6264,
        6490
    ],
    "cari": [
        67
    ],
    "chari": [
        67
    ],
    "chariar": [
        67
    ],
    "chung": [
        6733,
        71,
        1683,
        4341,
        4342,
        6062,
        6063,
        1694
    ],
    "chang": [
        5312,
        1651,
        6062,
        6063,
        71,
        5701,
        5702,
        5703
    ],
    "cn": [
        71,
        95,
        107,
        128,
        195,
        201,
        364,
        486,
        487,
        511,
        598,
        641,
        660,
        661,
        744,
        764,
        765,
        862,
        928,
        930,
        963,
        997,
        999,
        1000,
        1001,
        1037,
        1057,
        1179,
        1211,
        1235,
        1245,
        1251,
        1267,
        1281,
        1286,
        1386,
        1398,
        1399,
        1400,
        1403,
        1494,
        1495,
        1521,
        1544,
        1550,
        1551,
        1580,
        1593,
        1595,
        1641,
        1645,
        1646,
        1691,
        1694,
        1713,
        1714,
        1717,
        1932,
        1977,
        1978,
        1979,
        1980,
        2013,
        2063,
        2110,
        2239,
        2251,
        2253,
        2321,
        2322,
        2523,
        2524,
        2525,
        2654,
        2655,
        2757,
        2760,
        2773,
        2893,
        2894,
        2895,
        2967,
        2970,
        2972,
        2973,
        2974,
        2975,
        2976,
        2978,
        2979,
        2980,
        2981,
        2983,
        2984,
        2985,
        2986,
        2987,
        2988,
        2989,
        2991,
        2995,
        2996,
        2997,
        2998,
        3004,
        3008,
        3037,
        3050,
        3061,
        3062,
        3080,
        3084,
        3086,
        3169,
        3170,
        3195,
        3283,
        3284,
        3287,
        3368,
        3372,
        3373,
        3375,
        3377,
        3428,
        3449,
        3464,
        3600,
        3642,
        3645,
        3646,
        3651,
        3731,
        3750,
        3794,
        3795,
        3997,
        4120,
        4130,
        4215,
        4220,
        4223,
        4249,
        4315,
        4322,
        4326,
        4341,
        4342,
        4381,
        4462,
        4471,
        4472,
        4498,
        4508,
        4509,
        4553,
        4558,
        4564,
        4565,
        4822,
        4824,
        4852,
        4886,
        4902,
        4903,
        4904,
        4912,
        4918,
        4928,
        4930,
        4932,
        4935,
        4936,
        4937,
        4950,
        5139,
        5155,
        5156,
        5197,
        5198,
        5200,
        5293,
        5588,
        5634,
        5678,
        5684,
        5686,
        5705,
        5729,
        5781,
        5782,
        5783,
        5836,
        5921,
        5954,
        5981,
        6029,
        6062,
        6063,
        6083,
        6095,
        6121,
        6201,
        6209,
        6210,
        6244,
        6428,
        6445,
        6720,
        6721,
        6801,
        6817,
        6859,
        6899,
        6900,
        6901,
        6902,
        6954,
        6969,
        7108,
        7236,
        7256,
        7372,
        7386,
        7519,
        7522,
        7529,
        7739,
        7844,
        7916,
        7918,
        8032,
        8041,
        8043,
        8146,
        8186,
        8276,
        8363,
        8369,
        8370,
        8371,
        8380,
        8399,
        8543,
        8559,
        8602,
        8611,
        8640,
        8657,
        8714,
        8748,
        8749,
        8753,
        8760,
        8761,
        8785,
        8790,
        8792,
        8796,
        8797,
        8801,
        8805,
        8806,
        8809,
        8810,
        8811,
        8812,
        8813,
        8819,
        8821,
        8824,
        8825,
        8833,
        8834,
        8835,
        8840,
        8841,
        8844,
        8845,
        8853,
        8856,
        8857,
        8858,
        8860,
        8883,
        8884,
        8885,
        8886,
        8887,
        8888,
        8889,
        8890,
        8891,
        8898,
        8904,
        8905,
        8908,
        8909,
        8910,
        8913,
        8914,
        8915,
        8916,
        8925,
        8926,
        8941,
        8947,
        8949,
        8950,
        8952,
        8953,
        8963,
        8964,
        8965,
        8966,
        8967,
        8968,
        8981,
        9004,
        9009,
        9013,
        9015,
        9016,
        9021,
        9022,
        9030,
        9036,
        9043,
        9044,
        9047,
        9048,
        9050,
        9062,
        9068,
        9069,
        9070,
        9075,
        9076,
        9079,
        9080,
        9146,
        9147,
        9181,
        9182,
        9183,
        9184,
        9188
    ],
    "china": [
        1267,
        1588,
        195,
        4852,
        8146,
        8909,
        71,
        95,
        107,
        128,
        201,
        364,
        486,
        487,
        511,
        598,
        641,
        660,
        661,
        744,
        764,
        765,
        862,
        928,
        930,
        963,
        997,
        999,
        1000,
        1001,
        1037,
        1057,
        1179,
        1211,
        1235,
        1245,
        1251,
        1281,
        1286,
        1386,
        1398,
        1399,
        1400,
        1403,
        1494,
        1495,
        1521,
        1544,
        1550,
        1551,
        1580,
        1593,
        1595,
        1641,
        1645,
        1646,
        1691,
        1694,
        1713,
        1714,
        1717,
        1932,
        1977,
        1978,
        1979,
        1980,
        2013,
        2063,
        2110,
        2239,
        2251,
        2253,
        2321,
        2322,
        2523,
        2524,
        2525,
        2654,
        2655,
        2757,
        2760,
        2773,
        2893,
        2894,
        2895,
        2967,
        2970,
        2972,
        2973,
        2974,
        2975,
        2976,
        2978,
        2979,
        2980,
        2981,
        2983,
        2984,
        2985,
        2986,
        2987,
        2988,
        2989,
        2991,
        2995,
        2996,
        2997,
        2998,
        3004,
        3008,
        3037,
        3050,
        3061,
        3062,
        3080,
        3084,
        3086,
        3169,
        3170,
        3195,
        3283,
        3284,
        3287,
        3368,
        3372,
        3373,
        3375,
        3377,
        3428,
        3449,
        3464,
        3600,
        3642,
        3645,
        3646,
        3651,
        3731,
        3750,
        3794,
        3795,
        3997,
        4120,
        4130,
        4215,
        4220,
        4223,
        4249,
        4315,
        4322,
        4326,
        4341,
        4342,
        4381,
        4462,
        4471,
        4472,
        4498,
        4508,
        4509,
        4553,
        4558,
        4564,
        4565,
        4822,
        4824,
        4886,
        4902,
        4903,
        4904,
        4912,
        4918,
        4928,
        4930,
        4932,
        4935,
        4936,
        4937,
        4950,
        5139,
        5155,
        5156,
        5197,
        5198,
        5200,
        5293,
        5588,
        5634,
        5678,
        5684,
        5686,
        5705,
        5729,
        5781,
        5782,
        5783,
        5836,
        5921,
        5954,
        5981,
        6029,
        6062,
        6063,
        6083,
        6095,
        6121,
        6201,
        6209,
        6210,
        6244,
        6428,
        6445,
        6720,
        6721,
        6801,
        6817,
        6859,
        6899,
        6900,
        6901,
        6902,
        6954,
        6969,
        7108,
        7236,
        7256,
        7372,
        7386,
        7519,
        7522,
        7529,
        7739,
        7844,
        7916,
        7918,
        8032,
        8041,
        8043,
        8186,
        8276,
        8363,
        8369,
        8370,
        8371,
        8380,
        8399,
        8543,
        8559,
        8602,
        8611,
        8640,
        8657,
        8714,
        8748,
        8749,
        8753,
        8760,
        8761,
        8785,
        8790,
        8792,
        8796,
        8797,
        8801,
        8805,
        8806,
        8809,
        8810,
        8811,
        8812,
        8813,
        8819,
        8821,
        8824,
        8825,
        8833,
        8834,
        8835,
        8840,
        8841,
        8844,
        8845,
        8853,
        8856,
        8857,
        8858,
        8860,
        8883,
        8884,
        8885,
        8886,
        8887,
        8888,
        8889,
        8890,
        8891,
        8898,
        8904,
        8905,
        8908,
        8910,
        8913,
        8914,
        8915,
        8916,
        8925,
        8926,
        8941,
        8947,
        8949,
        8950,
        8952,
        8953,
        8963,
        8964,
        8965,
        8966,
        8967,
        8968,
        8981,
        9004,
        9009,
        9013,
        9015,
        9016,
        9021,
        9022,
        9030,
        9036,
        9043,
        9044,
        9047,
        9048,
        9050,
        9062,
        9068,
        9069,
        9070,
        9075,
        9076,
        9079,
        9080,
        9146,
        9147,
        9181,
        9182,
        9183,
        9184,
        9188
    ],
    "cubulco": [
        75
    ],
    "coroá": [
        77
    ],
    "chícham": [
        79
    ],
    "colloquial": [
        456,
        9077,
        9078,
        81
    ],
    "cypriot": [
        83,
        84,
        85
    ],
    "cypriot arabic": [
        83,
        84,
        85
    ],
    "cypriot maronite arabic": [
        83,
        84,
        85
    ],
    "cy": [
        83,
        84,
        85,
        2059,
        2092,
        2141,
        2764,
        7697
    ],
    "cyprus": [
        83,
        84,
        85,
        2059,
        2092,
        2141,
        2764,
        7697
    ],
    "cherkes": [
        108,
        109,
        110
    ],
    "circassian": [
        108,
        109,
        110,
        3481
    ],
    "caledonia": [
        121,
        222,
        319,
        356,
        402,
        571,
        1034,
        1221,
        1340,
        1474,
        1507,
        1842,
        1999,
        2451,
        2501,
        3098,
        3111,
        3319,
        3324,
        3542,
        4865,
        5050,
        5089,
        5393,
        5399,
        5400,
        5401,
        5725,
        6165,
        6206,
        6260,
        6290,
        6873,
        8033,
        8280,
        8838
    ],
    "chombrau": [
        123
    ],
    "chomrau": [
        123
    ],
    "cluster": [
        1595,
        138
    ],
    "chini": [
        141
    ],
    "criollo": [
        2416,
        146
    ],
    "crucino": [
        150
    ],
    "cd": [
        157,
        281,
        480,
        638,
        646,
        674,
        679,
        834,
        849,
        858,
        859,
        889,
        899,
        903,
        919,
        945,
        950,
        955,
        980,
        994,
        1007,
        1033,
        1070,
        1083,
        1091,
        1176,
        1190,
        1233,
        1241,
        1244,
        1254,
        1279,
        1309,
        1311,
        1812,
        1867,
        1923,
        1942,
        2049,
        2065,
        2401,
        2412,
        2426,
        2496,
        2613,
        2656,
        2750,
        2906,
        2911,
        2927,
        2957,
        3031,
        3083,
        3355,
        3410,
        3486,
        3527,
        3528,
        3537,
        3569,
        3620,
        3667,
        3668,
        3753,
        3814,
        3845,
        3885,
        3975,
        3987,
        4001,
        4005,
        4090,
        4096,
        4183,
        4204,
        4266,
        4269,
        4274,
        4276,
        4284,
        4306,
        4312,
        4328,
        4334,
        4348,
        4401,
        4419,
        4438,
        4445,
        4450,
        4454,
        4456,
        4492,
        4517,
        4518,
        4524,
        4548,
        4660,
        4661,
        4662,
        4664,
        4666,
        4667,
        4710,
        4925,
        4942,
        5082,
        5204,
        5212,
        5234,
        5313,
        5331,
        5368,
        5369,
        5377,
        5380,
        5421,
        5422,
        5423,
        5490,
        5491,
        5533,
        5549,
        5553,
        5592,
        5633,
        5717,
        5728,
        5746,
        5772,
        5789,
        5793,
        5796,
        5814,
        5873,
        5908,
        5910,
        6021,
        6100,
        6204,
        6252,
        6275,
        6568,
        6832,
        6852,
        6932,
        6959,
        6986,
        6995,
        6996,
        7026,
        7027,
        7028,
        7038,
        7039,
        7188,
        7225,
        7230,
        7231,
        7232,
        7287,
        7315,
        7341,
        7347,
        7418,
        7503,
        7572,
        7609,
        7652,
        8061,
        8316,
        8722,
        8774,
        8843,
        8861,
        8867,
        8878,
        9074,
        9082,
        9086,
        9096,
        9097,
        9099,
        9103,
        9106,
        9108
    ],
    "congo": [
        7230,
        7231,
        3620,
        4096,
        5490,
        6213,
        463,
        464,
        674,
        899,
        3298,
        3569,
        3668,
        3814,
        4001,
        4276,
        4868,
        4942,
        4979,
        5082,
        5423,
        5772,
        6995,
        6996,
        7026,
        8722,
        9103,
        253,
        731,
        907,
        966,
        1010,
        1180,
        1218,
        1247,
        1773,
        2054,
        2428,
        3151,
        3759,
        3857,
        4075,
        4126,
        4257,
        4382,
        4422,
        4611,
        4671,
        4672,
        4674,
        4967,
        5359,
        5371,
        5444,
        5507,
        5819,
        6754,
        7729,
        7864,
        7876,
        8083,
        8510,
        9104,
        157,
        281,
        480,
        638,
        646,
        679,
        834,
        849,
        858,
        859,
        889,
        903,
        919,
        945,
        950,
        955,
        980,
        994,
        1007,
        1033,
        1070,
        1083,
        1091,
        1176,
        1190,
        1233,
        1241,
        1244,
        1254,
        1279,
        1309,
        1311,
        1812,
        1867,
        1923,
        1942,
        2049,
        2065,
        2401,
        2412,
        2426,
        2496,
        2613,
        2656,
        2750,
        2906,
        2911,
        2927,
        2957,
        3031,
        3083,
        3355,
        3410,
        3486,
        3527,
        3528,
        3537,
        3667,
        3753,
        3845,
        3885,
        3975,
        3987,
        4005,
        4090,
        4183,
        4204,
        4266,
        4269,
        4274,
        4284,
        4306,
        4312,
        4328,
        4334,
        4348,
        4401,
        4419,
        4438,
        4445,
        4450,
        4454,
        4456,
        4492,
        4517,
        4518,
        4524,
        4548,
        4660,
        4661,
        4662,
        4664,
        4666,
        4667,
        4710,
        4925,
        5204,
        5212,
        5234,
        5313,
        5331,
        5368,
        5369,
        5377,
        5380,
        5421,
        5422,
        5491,
        5533,
        5549,
        5553,
        5592,
        5633,
        5717,
        5728,
        5746,
        5789,
        5793,
        5796,
        5814,
        5873,
        5908,
        5910,
        6021,
        6100,
        6204,
        6252,
        6275,
        6568,
        6832,
        6852,
        6932,
        6959,
        6986,
        7027,
        7028,
        7038,
        7039,
        7188,
        7225,
        7232,
        7287,
        7315,
        7341,
        7347,
        7418,
        7503,
        7572,
        7609,
        7652,
        8061,
        8316,
        8774,
        8843,
        8861,
        8867,
        8878,
        9074,
        9082,
        9086,
        9096,
        9097,
        9099,
        9106,
        9108
    ],
    "cagayan": [
        169,
        2511,
        6896,
        503,
        2008
    ],
    "central cagayan agta": [
        169
    ],
    "copper river": [
        193
    ],
    "copper": [
        193,
        5129
    ],
    "caribbean": [
        200,
        3013,
        3447,
        1306,
        3064,
        3315,
        2257
    ],
    "chahar-aimaq": [
        212
    ],
    "char aimaq": [
        212
    ],
    "char": [
        212
    ],
    "cf": [
        219,
        568,
        649,
        704,
        747,
        754,
        874,
        890,
        893,
        948,
        1023,
        1028,
        1060,
        1212,
        1807,
        1821,
        2427,
        2539,
        2540,
        2545,
        2555,
        2556,
        2560,
        2583,
        2608,
        2722,
        2792,
        2862,
        3466,
        3490,
        3518,
        3969,
        4037,
        4144,
        4347,
        4421,
        4423,
        4431,
        4648,
        4665,
        4753,
        5277,
        5320,
        5382,
        5424,
        5426,
        5571,
        5816,
        6249,
        6717,
        6804,
        6999,
        7078,
        7934,
        8046,
        8727,
        8826,
        8932
    ],
    "central african republic": [
        219,
        568,
        649,
        704,
        747,
        754,
        874,
        890,
        893,
        948,
        1023,
        1028,
        1060,
        1212,
        1807,
        1821,
        2427,
        2539,
        2540,
        2545,
        2555,
        2556,
        2560,
        2583,
        2608,
        2722,
        2792,
        2862,
        3466,
        3490,
        3518,
        3969,
        4037,
        4144,
        4347,
        4421,
        4423,
        4431,
        4648,
        4665,
        4753,
        5277,
        5320,
        5382,
        5424,
        5426,
        5571,
        5816,
        6249,
        6717,
        6804,
        6999,
        7078,
        7934,
        8046,
        8727,
        8826,
        8932
    ],
    "cemba": [
        249
    ],
    "chamba": [
        249,
        1375,
        4192,
        4193,
        5366
    ],
    "cg": [
        253,
        731,
        907,
        966,
        1010,
        1180,
        1218,
        1247,
        1773,
        2054,
        2428,
        3151,
        3298,
        3759,
        3857,
        4075,
        4126,
        4257,
        4382,
        4422,
        4611,
        4671,
        4672,
        4674,
        4868,
        4967,
        4979,
        5359,
        5371,
        5444,
        5507,
        5819,
        6754,
        7729,
        7864,
        7876,
        8083,
        8510,
        9104
    ],
    "cl": [
        258,
        446,
        1635,
        2263,
        3078,
        4040,
        6470,
        8723
    ],
    "chile": [
        258,
        446,
        1635,
        2263,
        3078,
        4040,
        6470,
        8723
    ],
    "chatans": [
        267
    ],
    "china-taiwan": [
        292,
        293,
        985,
        1288,
        1303,
        1510,
        1966,
        2415,
        3463,
        5294,
        5295,
        5296,
        5297,
        6279,
        6379,
        6388,
        6389,
        7134,
        7262,
        7295,
        7314,
        7324,
        7325,
        7326,
        7722,
        7745,
        7747,
        7816,
        8030,
        8557,
        8644,
        9020,
        9026,
        9040
    ],
    "chad": [
        6855,
        6856,
        2685,
        4207,
        4387,
        4647,
        4655,
        4656,
        4994,
        7587,
        294,
        432,
        659,
        697,
        699,
        732,
        839,
        881,
        952,
        1130,
        1149,
        1171,
        1196,
        1201,
        1210,
        1268,
        1402,
        1505,
        1722,
        1729,
        1742,
        1870,
        1971,
        2047,
        2380,
        2407,
        2460,
        2489,
        2509,
        2585,
        2588,
        2676,
        2679,
        2751,
        2759,
        2832,
        2923,
        3033,
        3354,
        3451,
        3488,
        3575,
        3671,
        3675,
        3746,
        3769,
        3868,
        3913,
        3989,
        4050,
        4053,
        4079,
        4093,
        4109,
        4148,
        4397,
        4638,
        4658,
        4699,
        4740,
        4744,
        4821,
        4883,
        4924,
        4939,
        4977,
        4983,
        4990,
        5077,
        5127,
        5134,
        5158,
        5169,
        5185,
        5233,
        5370,
        5383,
        5471,
        5563,
        5593,
        5605,
        5639,
        5820,
        6594,
        6658,
        6691,
        6700,
        6893,
        7036,
        7041,
        7252,
        7278,
        7323,
        7589,
        7619,
        7709,
        7789,
        7797,
        7897,
        8091,
        8680,
        9055,
        9107,
        9151
    ],
    "churuba": [
        315
    ],
    "canala": [
        319
    ],
    "chin, anu-khongso": [
        326
    ],
    "chin": [
        326,
        795,
        1360,
        1412,
        1413,
        1414,
        1415,
        1416,
        1417,
        1418,
        1419,
        1420,
        1421,
        1424,
        1428,
        1429,
        1430,
        1431,
        1432,
        1503,
        1519,
        1525,
        1542,
        1545,
        1547,
        1557,
        1636,
        1637,
        1639,
        1651,
        1654,
        1658,
        1659,
        1664,
        1718,
        1734,
        1735,
        1736,
        1737,
        1738,
        2968,
        5048,
        5189,
        6075,
        6605,
        6798,
        7369,
        7378,
        8214,
        9185,
        4533,
        4534,
        4535,
        1538,
        9115
    ],
    "cha’oie": [
        329
    ],
    "cho’oje": [
        329
    ],
    "chhika-chhiki": [
        330
    ],
    "caramanta": [
        1602,
        334
    ],
    "cartama": [
        334
    ],
    "coastal": [
        3698,
        843,
        844,
        4443,
        4807,
        4816,
        6241,
        6242,
        6243,
        8532,
        8896,
        372
    ],
    "central raga": [
        384
    ],
    "coyotero": [
        391
    ],
    "comoros": [
        417,
        2441,
        8255,
        8292,
        8293,
        9005,
        9006
    ],
    "chiripuno": [
        445
    ],
    "chiripunu": [
        445
    ],
    "cavina": [
        447
    ],
    "colloquial arabic": [
        456
    ],
    "casu": [
        460
    ],
    "chasu": [
        460
    ],
    "chiasu": [
        460
    ],
    "casuarina": [
        462
    ],
    "coast": [
        462,
        702,
        1638,
        1306,
        1307,
        1588,
        5734
    ],
    "casuarina coast asmat": [
        462
    ],
    "congolaise": [
        463,
        464
    ],
    "cishingini": [
        466,
        7749
    ],
    "chisingini": [
        466
    ],
    "carinthian sign language": [
        475
    ],
    "carinthian": [
        475,
        2603
    ],
    "clay": [
        502
    ],
    "cieng": [
        504
    ],
    "central asian arabic": [
        531
    ],
    "canoa": [
        545
    ],
    "canoe": [
        545
    ],
    "canoeiro": [
        545,
        6533
    ],
    "canoeiros": [
        545
    ],
    "cara preta": [
        545
    ],
    "cara": [
        1426,
        545
    ],
    "carijó": [
        545
    ],
    "cicipu": [
        548
    ],
    "cipu": [
        548
    ],
    "central awyu": [
        560
    ],
    "coroino": [
        584
    ],
    "cowtail phula": [
        598,
        8792,
        8965
    ],
    "cowtail": [
        598,
        8792,
        8965
    ],
    "cruz": [
        605,
        4629,
        5560,
        5720,
        8663
    ],
    "central-eastern choiseul": [
        610
    ],
    "central-eastern": [
        2493,
        610
    ],
    "choiseul": [
        610
    ],
    "cunipusana": [
        613,
        4784
    ],
    "chopechop": [
        650
    ],
    "chɔpəchɔp": [
        650
    ],
    "central bai": [
        660,
        661
    ],
    "carrier": [
        1333,
        1334,
        1623,
        1624,
        677
    ],
    "catrú": [
        687
    ],
    "cai": [
        693
    ],
    "castor": [
        714,
        715
    ],
    "chibemba": [
        727,
        728
    ],
    "chiwemba": [
        727,
        728
    ],
    "cibemba": [
        727,
        728
    ],
    "central bété": [
        733
    ],
    "chufie’": [
        752
    ],
    "chuufi": [
        752
    ],
    "chamarwa": [
        781
    ],
    "clata": [
        786
    ],
    "chin, bawm": [
        795
    ],
    "central bicolano": [
        843,
        844
    ],
    "coastal bikol": [
        843,
        844
    ],
    "chao": [
        1361,
        7023,
        7024,
        862,
        9188
    ],
    "central jewish neo-aramaic": [
        863
    ],
    "chichamachu": [
        871
    ],
    "cusi": [
        908
    ],
    "coola": [
        914
    ],
    "catanduanes": [
        924,
        1670
    ],
    "coastal-virac bikol": [
        924
    ],
    "coastal-virac": [
        924
    ],
    "chun": [
        928,
        929,
        930,
        931
    ],
    "chrambo": [
        958
    ],
    "chirambo": [
        958
    ],
    "cirambo": [
        958
    ],
    "changping": [
        963
    ],
    "central bontoc": [
        975,
        6487
    ],
    "central tibetan": [
        997,
        1000,
        1001
    ],
    "cèn bèrom": [
        1012
    ],
    "cèn": [
        1012
    ],
    "ciewe": [
        1014
    ],
    "cièwè": [
        1014
    ],
    "cèwè": [
        1014
    ],
    "chombulon": [
        1050
    ],
    "cibaangi": [
        1073
    ],
    "central mbo": [
        1075
    ],
    "cambodia": [
        1653,
        1078,
        1478,
        1479,
        1480,
        1535,
        1537,
        2962,
        3420,
        3551,
        3791,
        3941,
        3945,
        5890,
        6061,
        6532,
        6733,
        6983,
        7166,
        7259,
        7276,
        7677,
        8501
    ],
    "chiquimiti": [
        1084
    ],
    "cr": [
        1092,
        1299,
        1490,
        1648,
        2265,
        2821
    ],
    "costa rica": [
        1092,
        1299,
        1490,
        1648,
        2265,
        2821
    ],
    "costa": [
        1648,
        1524,
        1577,
        4819,
        5224,
        1092,
        1299,
        1490,
        2265,
        2821
    ],
    "chiem": [
        1478,
        1479,
        1480,
        1485,
        1486,
        1487,
        1105
    ],
    "cho’ wushike": [
        1119
    ],
    "cho’": [
        1119
    ],
    "came-masa": [
        1129
    ],
    "come masa": [
        1129
    ],
    "come": [
        1129
    ],
    "comea": [
        1129
    ],
    "comematsa": [
        1129
    ],
    "cakap karo": [
        1166,
        1167
    ],
    "cakap": [
        1166,
        1167
    ],
    "chibarwe": [
        1228
    ],
    "chirue": [
        1228
    ],
    "cibalke": [
        1228
    ],
    "cwi": [
        1246
    ],
    "coo": [
        1246
    ],
    "cwi bwamu": [
        1246
    ],
    "china buriat": [
        1267
    ],
    "chepang": [
        1395,
        1396,
        1278
    ],
    "corogaama": [
        1300,
        1301
    ],
    "corogama": [
        1300,
        1301
    ],
    "central buang": [
        1304
    ],
    "centros": [
        1315
    ],
    "catalan": [
        1323,
        1324,
        1325,
        1326,
        1327,
        1631
    ],
    "català": [
        1323,
        1324,
        1325,
        1326,
        1327
    ],
    "catalan-valencian-balear": [
        1323,
        1327
    ],
    "catalonian": [
        1323,
        1327,
        1631
    ],
    "catalán": [
        1323,
        1327
    ],
    "ch’orti’": [
        1328
    ],
    "chꞌortiꞌ": [
        1328
    ],
    "chorti’": [
        1328
    ],
    "chortí": [
        1328
    ],
    "carib": [
        1345,
        1599,
        8935,
        1329,
        4632
    ],
    "caribe": [
        1329,
        1345
    ],
    "central american carib": [
        1329
    ],
    "chuj": [
        1330
    ],
    "chapai": [
        1330
    ],
    "chuh": [
        1330
    ],
    "chuhe": [
        1330
    ],
    "chuj de san mateo ixtatán": [
        1330
    ],
    "chuje": [
        1330
    ],
    "caddo": [
        1331
    ],
    "caddoe": [
        1331
    ],
    "carrier, southern": [
        1333,
        1334
    ],
    "cahuarano": [
        1336
    ],
    "chané": [
        1337
    ],
    "cakchiquel": [
        1338,
        1561
    ],
    "carolinian": [
        1339,
        7678
    ],
    "cemuhî": [
        1340
    ],
    "camuhi": [
        1340
    ],
    "camuki": [
        1340
    ],
    "cemuhi": [
        1340
    ],
    "cèmuhî": [
        1340
    ],
    "chambri": [
        1341
    ],
    "chácobo": [
        1342
    ],
    "chákobo": [
        1342
    ],
    "chipaya": [
        1343
    ],
    "car": [
        1344
    ],
    "car nicobarese": [
        1344
    ],
    "cariña": [
        1345
    ],
    "chimané": [
        1346
    ],
    "cavineña": [
        1347
    ],
    "callawalla": [
        1348
    ],
    "callahuaya": [
        1348
    ],
    "callawaya": [
        1348
    ],
    "chiquitano": [
        1349
    ],
    "chikitano": [
        1349
    ],
    "chiquito": [
        1349
    ],
    "cayuga": [
        1350
    ],
    "canichana": [
        1351
    ],
    "cabiyarí": [
        1352
    ],
    "cabiuarí": [
        1352
    ],
    "cabuyari": [
        1352
    ],
    "cauyarí": [
        1352
    ],
    "cuyare": [
        1352
    ],
    "carapana": [
        1353
    ],
    "carapana-tapuya": [
        1353
    ],
    "carapanã": [
        1353
    ],
    "carijona": [
        1354
    ],
    "carifuna": [
        1354
    ],
    "carihona": [
        1354
    ],
    "chimila": [
        1355
    ],
    "caca weranos": [
        1355
    ],
    "caca": [
        1355
    ],
    "chimile": [
        1355
    ],
    "chachi": [
        1356
    ],
    "cha'palaa": [
        1356
    ],
    "cayapa": [
        1356
    ],
    "chachilla": [
        1356
    ],
    "cha’ palaachi": [
        1356
    ],
    "cha’": [
        1656,
        1669,
        1710,
        1356,
        1528,
        1676,
        1716
    ],
    "cha’palaa": [
        1356
    ],
    "cha’palaachi": [
        1356
    ],
    "cabe": [
        1357
    ],
    "caabe": [
        1357
    ],
    "chavacano": [
        1358,
        1359
    ],
    "chabacano": [
        1358,
        1359
    ],
    "chabakano": [
        1358,
        1359
    ],
    "chin, bualkhaw": [
        1360
    ],
    "chao dong": [
        1361
    ],
    "chaodon": [
        1361
    ],
    "chokobo": [
        1362
    ],
    "cikobu": [
        1362
    ],
    "cokobanci": [
        1362
    ],
    "cokobawa": [
        1362
    ],
    "cokobo": [
        1362
    ],
    "cuba": [
        1363,
        1634,
        2266,
        4531
    ],
    "cachibo": [
        1364
    ],
    "cacibo": [
        1364
    ],
    "cahivo": [
        1364
    ],
    "cashibo-cacataibo": [
        1364
    ],
    "caxibo": [
        1364
    ],
    "cashinahua": [
        1365
    ],
    "caxinahua": [
        1365
    ],
    "caxinauá": [
        1365
    ],
    "caxinawá": [
        1365
    ],
    "cahuapa": [
        1366
    ],
    "cahuapana": [
        1366
    ],
    "campo piyapi": [
        1366
    ],
    "campo": [
        1366,
        1851
    ],
    "chahui": [
        1366
    ],
    "chawi": [
        1366,
        1376,
        6860,
        6861,
        6862
    ],
    "chayabita": [
        1366
    ],
    "chayahuita": [
        1366
    ],
    "chayawita": [
        1366
    ],
    "chayhuita": [
        1366
    ],
    "candoshi": [
        1367
    ],
    "candoshi-shapra": [
        1367
    ],
    "candoxi": [
        1367
    ],
    "cacua": [
        1368
    ],
    "cakua": [
        1368
    ],
    "cabalian": [
        1369
    ],
    "cabalianon": [
        1369
    ],
    "carabayo": [
        1370
    ],
    "cauca": [
        1371
    ],
    "chamicuro": [
        1372
    ],
    "chamekolo": [
        1372
    ],
    "chamicolo": [
        1372
    ],
    "chamicura": [
        1372
    ],
    "cafundo creole": [
        1373
    ],
    "cafundo": [
        1373
    ],
    "chopi": [
        1374
    ],
    "chichopi": [
        1374
    ],
    "cicopi": [
        1374
    ],
    "copi": [
        1374
    ],
    "chamba daka": [
        1375
    ],
    "cawai": [
        1376
    ],
    "cawe": [
        1376
    ],
    "cawi": [
        1376
    ],
    "chawai": [
        1376
    ],
    "chawe": [
        1376
    ],
    "cassanga": [
        1377
    ],
    "cutchi-swahili": [
        1378
    ],
    "chitties malay creole": [
        1379
    ],
    "chitties": [
        1379
    ],
    "chinantec, comaltepec": [
        1380
    ],
    "chinantec": [
        1380,
        1444,
        1454,
        1461,
        1516,
        1548,
        1555,
        1584,
        1629,
        1644,
        1660,
        1665,
        1682,
        1702
    ],
    "comaltepec": [
        1380,
        1444,
        9122
    ],
    "chinanteco de santiago comaltepec": [
        1380
    ],
    "chinanteco": [
        1380,
        1444,
        1461,
        1516,
        1548,
        1555,
        1584,
        1644,
        1660,
        1665,
        1682,
        1702
    ],
    "comaltepec chinantec": [
        1380,
        1444
    ],
    "chakma": [
        1381,
        1382,
        1383,
        1384
    ],
    "chakama": [
        1381,
        1382,
        1383,
        1384
    ],
    "changma kodha": [
        1381,
        1382,
        1384
    ],
    "changma": [
        1381,
        1382,
        1383,
        1384
    ],
    "changma vaj": [
        1381,
        1382,
        1383,
        1384
    ],
    "cacaopera": [
        1385
    ],
    "choni": [
        1386
    ],
    "chona": [
        1386
    ],
    "chone": [
        1386
    ],
    "cone": [
        1386
    ],
    "chenchu": [
        1387
    ],
    "chenchucoolam": [
        1387
    ],
    "chenchwar": [
        1387
    ],
    "chensulu": [
        1387
    ],
    "chenswar": [
        1387
    ],
    "choncharu": [
        1387
    ],
    "chiru": [
        1388,
        1389
    ],
    "chamari": [
        1390
    ],
    "chambeali": [
        1391,
        1392
    ],
    "cameali": [
        1391,
        1392
    ],
    "chamaya": [
        1391,
        1392
    ],
    "chambiali": [
        1391,
        1392
    ],
    "chambiyali": [
        1391,
        1392
    ],
    "chamiyali pahari": [
        1391,
        1392
    ],
    "chamiyali": [
        1391,
        1392
    ],
    "chamrali": [
        1391,
        1392
    ],
    "chamya": [
        1391,
        1392
    ],
    "chamĕāḷī": [
        1391,
        1392
    ],
    "chodri": [
        1393
    ],
    "chaudhari": [
        1393,
        7476
    ],
    "chaudri": [
        1393
    ],
    "chodhari": [
        1393
    ],
    "choudhara": [
        1393
    ],
    "choudhary": [
        1393
    ],
    "chowdhary": [
        1393
    ],
    "churahi": [
        1394
    ],
    "chaurahi": [
        1394
    ],
    "churahi pahari": [
        1394
    ],
    "churai pahari": [
        1394
    ],
    "churai": [
        1394
    ],
    "cyo’bang": [
        1395,
        1396
    ],
    "chaudangsi": [
        1397
    ],
    "chanpa lo": [
        1397
    ],
    "chanpa": [
        1397
    ],
    "chaudans lo": [
        1397
    ],
    "chaudans": [
        1397
    ],
    "chinese, min dong": [
        1398,
        1399,
        1400
    ],
    "chinese": [
        1398,
        1399,
        1400,
        1494,
        1495,
        1588,
        1593,
        1641,
        1713,
        1714,
        1717,
        2523,
        2524,
        2525,
        2893,
        2894,
        2895,
        3061,
        3062,
        4950,
        5293,
        5294,
        5295,
        5296,
        5297,
        8369,
        8370,
        8371,
        8923,
        8924,
        8925,
        8926,
        9018,
        9019,
        9020,
        9021,
        9022,
        9023,
        9024,
        9025,
        9026,
        9027,
        9028,
        9029,
        9030,
        9031,
        9032,
        9033,
        9034,
        9035,
        9036,
        9037,
        9038,
        9039,
        9040,
        9041,
        9042,
        9050,
        4508,
        4509,
        4564,
        4565,
        5836,
        4605,
        6089,
        7386,
        7387,
        1550,
        1551,
        1645,
        1646
    ],
    "cinda-regi-tiyal": [
        1401
    ],
    "chadian sign language": [
        1402
    ],
    "chadian": [
        1402,
        6855,
        6856
    ],
    "chadong": [
        1403
    ],
    "cha dong": [
        1403
    ],
    "cha": [
        1403,
        5812,
        4023,
        6062,
        6063
    ],
    "chadonghua": [
        1403
    ],
    "chadongyu": [
        1403
    ],
    "chechen": [
        1405,
        1406,
        1407
    ],
    "chehalis, lower": [
        1408
    ],
    "chehalis": [
        1408,
        1482
    ],
    "cebuano": [
        1409,
        1410
    ],
    "chamacoco": [
        1411
    ],
    "chin, eastern khumi": [
        1412,
        1413,
        1414,
        1415,
        1416,
        1417,
        1418,
        1419,
        1420,
        1421
    ],
    "chin, eastern khumi asang (khongso) dialect": [
        1413
    ],
    "chin, eastern khumi hnise dialect": [
        1414
    ],
    "chin, eastern khumi kanise dialect": [
        1415
    ],
    "chin, eastern khumi khawng tuu dialect": [
        1416
    ],
    "chfin, eastern khumi khong tu dialect": [
        1417
    ],
    "chfin": [
        1417
    ],
    "chin, eastern khumi lemi dialect": [
        1418
    ],
    "chin, eastern khumi likhy dialect": [
        1419
    ],
    "chin, eastern khumi rengcaa dialect": [
        1420
    ],
    "chin, eastern khumi rengcaa dialect ta-aw alphabet": [
        1421
    ],
    "cen": [
        1422,
        1423
    ],
    "chen": [
        1422
    ],
    "centúúm": [
        1423
    ],
    "cen tuum": [
        1423
    ],
    "chin, ekai": [
        1424
    ],
    "chara": [
        1598,
        1426
    ],
    "chomo": [
        1427
    ],
    "como karim": [
        1427
    ],
    "como": [
        1427,
        8580
    ],
    "chin, falam": [
        1428,
        1429,
        1430,
        1431,
        1432
    ],
    "chin, falam khualshim": [
        1430
    ],
    "chin, falam lente": [
        1431
    ],
    "chin, falam zanniat": [
        1432
    ],
    "changriwa": [
        1433
    ],
    "cagayano": [
        1434,
        6896
    ],
    "chiga": [
        1435
    ],
    "ciga": [
        1435
    ],
    "chocangacakha": [
        1436
    ],
    "chocangaca": [
        1436
    ],
    "chocha ngacha": [
        1436
    ],
    "chocha": [
        1436
    ],
    "chamorro": [
        1437
    ],
    "chamorru": [
        1437
    ],
    "chibcha": [
        1438
    ],
    "catawba": [
        1439
    ],
    "chontal, highland oaxaca": [
        1440
    ],
    "chontal": [
        1440,
        1441,
        1524
    ],
    "chontal de oaxaca alto": [
        1440
    ],
    "chontal de la sierra de oaxaca": [
        1440
    ],
    "chontal, tabasco": [
        1441
    ],
    "chontal maya": [
        1441
    ],
    "chontal de tabasco": [
        1441
    ],
    "chagatai": [
        1442
    ],
    "chaghatai": [
        1442
    ],
    "chaghatay": [
        1442
    ],
    "chinook": [
        1443,
        1449,
        1450,
        8150
    ],
    "chinantec, ojitlán": [
        1444
    ],
    "chinanteco del norte": [
        1444
    ],
    "chuukese": [
        1445
    ],
    "chuk": [
        1445
    ],
    "chuuk": [
        1445
    ],
    "cahuilla": [
        1446
    ],
    "cheremis": [
        1447,
        1448,
        5049
    ],
    "chinook wawa": [
        1449,
        1450
    ],
    "chinook jargon": [
        1449,
        1450
    ],
    "chinook pidgin": [
        1449,
        1450
    ],
    "chinuk wawa": [
        1449,
        1450
    ],
    "chinuk": [
        1449,
        1450
    ],
    "choctaw": [
        1451
    ],
    "chahta": [
        1451
    ],
    "chahta anumpa": [
        1451
    ],
    "chinantec, quiotepec": [
        1454
    ],
    "cherokee": [
        1455,
        1456
    ],
    "cholón": [
        1457
    ],
    "chuwabu": [
        1458
    ],
    "chichwabo": [
        1458
    ],
    "chuabo": [
        1458
    ],
    "chuwabo": [
        1458
    ],
    "chwabo": [
        1458
    ],
    "cicuabo": [
        1458
    ],
    "cuabo": [
        1458
    ],
    "cuwabo": [
        1458
    ],
    "chantyal": [
        1459
    ],
    "chantel": [
        1459
    ],
    "chhantel": [
        1459
    ],
    "chhantyal": [
        1459
    ],
    "cheyenne": [
        1460
    ],
    "chinantec, ozumacín": [
        1461
    ],
    "chinanteco de ayotzintepec": [
        1461
    ],
    "chinanteco del sureste alto": [
        1461
    ],
    "cia-cia": [
        1462,
        1463,
        1464
    ],
    "ci gbe": [
        1465
    ],
    "cigbe": [
        1465
    ],
    "chickasaw": [
        1466
    ],
    "chikashshanompa’": [
        1466
    ],
    "chimariko": [
        1467
    ],
    "cineni": [
        1468
    ],
    "cinene": [
        1468
    ],
    "chinali": [
        1469
    ],
    "chana": [
        1469,
        2758
    ],
    "channali": [
        1469
    ],
    "chinal": [
        1469
    ],
    "chitkuli": [
        1470
    ],
    "chhitkul-rakchham": [
        1470
    ],
    "chitkhuli": [
        1470
    ],
    "chitkuli kinnauri": [
        1470
    ],
    "cimbrian": [
        1471
    ],
    "cinta larga": [
        1472
    ],
    "cinta": [
        1472
    ],
    "chiapanec": [
        1473
    ],
    "chaipanec": [
        1473
    ],
    "chiapaneco": [
        1473
    ],
    "chiapaneko": [
        1473
    ],
    "ciiri": [
        1474
    ],
    "ciri": [
        1474
    ],
    "couli": [
        1474
    ],
    "chippewa": [
        1475,
        1476,
        5994
    ],
    "chaima": [
        1477
    ],
    "chayma": [
        1477
    ],
    "cham, western": [
        1478,
        1479,
        1480
    ],
    "cham": [
        1478,
        1479,
        1480,
        1485,
        1486,
        1487,
        5837,
        5701,
        5702,
        5703,
        3051,
        3086,
        7654
    ],
    "cam": [
        1478,
        1890,
        3702,
        3703,
        3704
    ],
    "cambodian cham": [
        1478,
        1479,
        1480
    ],
    "cambodian": [
        1653,
        1478,
        1479,
        1480,
        3791
    ],
    "chăm": [
        1478,
        1479,
        1480
    ],
    "chru": [
        1481
    ],
    "cadoe loang": [
        1481
    ],
    "cadoe": [
        1481
    ],
    "cho ru": [
        1481
    ],
    "cho": [
        1481,
        1622,
        3419,
        3420,
        5189
    ],
    "choru": [
        1481
    ],
    "chrau hma": [
        1481
    ],
    "chrau": [
        1622,
        1481
    ],
    "chu": [
        1481,
        6062,
        6063
    ],
    "chu ru": [
        1481
    ],
    "churu": [
        1481
    ],
    "cru": [
        1481
    ],
    "chehalis, upper": [
        1482
    ],
    "chamalal": [
        1483
    ],
    "camalal": [
        1483
    ],
    "chamalal mitsts": [
        1483
    ],
    "chamalin": [
        1483
    ],
    "chokwe": [
        1484
    ],
    "ciokwe": [
        1484
    ],
    "cokwe": [
        1484
    ],
    "cham, eastern": [
        1485,
        1486,
        1487
    ],
    "chiem thành": [
        1485,
        1486,
        1487
    ],
    "chenapian": [
        1488
    ],
    "chenap": [
        1488
    ],
    "cabécar": [
        1490
    ],
    "chirripó": [
        1490
    ],
    "chuave": [
        1493
    ],
    "chinese, jinyu": [
        1494,
        1495
    ],
    "central kurdish": [
        1496,
        1497,
        1498
    ],
    "chak": [
        1499
    ],
    "chibak": [
        1500
    ],
    "chibbak": [
        1500
    ],
    "chibbuk": [
        1500
    ],
    "chibok": [
        1500
    ],
    "chibuk": [
        1500
    ],
    "cibak": [
        1500
    ],
    "cibuk": [
        1500
    ],
    "cíbɔ̀k": [
        1500
    ],
    "chakavian": [
        1501,
        1502
    ],
    "croatian": [
        1647,
        3042,
        3043,
        3044,
        1501,
        7220
    ],
    "chakavski": [
        1501,
        1502
    ],
    "chekavski": [
        1501,
        1502
    ],
    "croatia": [
        1647,
        1501,
        1502,
        1894,
        3042,
        3044,
        3258,
        6626
    ],
    "chin, kaang": [
        1503
    ],
    "chakosi": [
        1504
    ],
    "chokosi": [
        1504
    ],
    "chokossi": [
        1504
    ],
    "chukchi": [
        1508
    ],
    "chukcha": [
        1508
    ],
    "chukchee": [
        1508
    ],
    "chukot": [
        1508
    ],
    "coushatta": [
        1509
    ],
    "cabaran": [
        1510
    ],
    "caka": [
        1511,
        2498
    ],
    "cakfem-mushere": [
        1512
    ],
    "chakfem": [
        1512
    ],
    "chokfem": [
        1512
    ],
    "cakchiquel-quiché mixed language": [
        1513
    ],
    "cakchiquel-quiché": [
        1513
    ],
    "cauque mixed language": [
        1513
    ],
    "cauque": [
        1513
    ],
    "chilcotin": [
        1515
    ],
    "ch’ih": [
        1515
    ],
    "chinantec, lealao": [
        1516
    ],
    "chinanteco de san juan lealao": [
        1516
    ],
    "chilisso": [
        1517
    ],
    "chiliss": [
        1517
    ],
    "chakali": [
        1518
    ],
    "chin, laitu": [
        1519
    ],
    "chala": [
        1522
    ],
    "cala": [
        1522
    ],
    "clallam": [
        1523
    ],
    "chontal, lowland oaxaca": [
        1524
    ],
    "chontal de oaxaca de la costa": [
        1524
    ],
    "chontal de la costa de oaxaca": [
        1524
    ],
    "chin, lautu": [
        1525
    ],
    "caluyanun": [
        1526
    ],
    "caluyanen": [
        1526
    ],
    "caluyanhon": [
        1526
    ],
    "caluyanon": [
        1526
    ],
    "chulym": [
        1527
    ],
    "chulim": [
        1527
    ],
    "chulym tatar": [
        1527
    ],
    "chulym-turkish": [
        1527
    ],
    "chatino, eastern highland": [
        1528
    ],
    "chatino": [
        1528,
        1656,
        1669,
        1676,
        1710,
        1716
    ],
    "chatino oriental alto": [
        1528
    ],
    "chatino de la zona alta oriental": [
        1528
    ],
    "cha’ jna’a": [
        1656,
        1669,
        1710,
        1528,
        1676,
        1716
    ],
    "chauma": [
        1529
    ],
    "che ma": [
        1529
    ],
    "che": [
        1529,
        1706,
        6625
    ],
    "cerma": [
        1530
    ],
    "classical mongolian": [
        1531
    ],
    "classical": [
        1531,
        5342,
        5758,
        5759,
        5760,
        5761,
        5762,
        6431,
        8432,
        8438,
        5254,
        7268
    ],
    "chami": [
        1532,
        6889
    ],
    "chamí emberá": [
        1532
    ],
    "chamí": [
        1532
    ],
    "campalagian": [
        1533
    ],
    "central bu nong": [
        1535,
        1536
    ],
    "central mnong": [
        1535,
        1536,
        1537
    ],
    "camtho": [
        1540
    ],
    "changthang": [
        1541
    ],
    "champas": [
        1541
    ],
    "changs-skat": [
        1541
    ],
    "changtang": [
        1541
    ],
    "changtang ladakhi": [
        1541
    ],
    "chin, uppu": [
        1542
    ],
    "chin pong": [
        1542
    ],
    "chin pung": [
        1542
    ],
    "chinbon chin": [
        1542
    ],
    "chinbon": [
        1542
    ],
    "chindwin chin": [
        1542
    ],
    "chindwin": [
        1542
    ],
    "chinpon": [
        1542
    ],
    "côông": [
        1543
    ],
    "ch’iang": [
        1544,
        6445
    ],
    "chin, hakha": [
        1545
    ],
    "chin, khumi": [
        1547
    ],
    "chinantec, lalana": [
        1548
    ],
    "chinanteco de san juan lalana": [
        1548
    ],
    "chinanteco del sureste bajo": [
        1548
    ],
    "con": [
        1549,
        8504
    ],
    "central asmat": [
        1554
    ],
    "chinantec, tepetotutla": [
        1555
    ],
    "chinanteco del oeste central bajo": [
        1555
    ],
    "chenoua": [
        1556
    ],
    "chenoui": [
        1556
    ],
    "chin, ngawn": [
        1557
    ],
    "cornish": [
        4072,
        1558,
        5838
    ],
    "corsican": [
        1559
    ],
    "corse": [
        1559
    ],
    "corsi": [
        1559
    ],
    "corso": [
        1559
    ],
    "corsu": [
        1559
    ],
    "còrso": [
        1559
    ],
    "cocos": [
        1560,
        2136,
        5071
    ],
    "cocos islands": [
        1560
    ],
    "cocos islands malay": [
        1560
    ],
    "chicomuceltec": [
        1561
    ],
    "cac’chiquel mam": [
        1561
    ],
    "cac’chiquel": [
        1561
    ],
    "cakchiquel mam": [
        1561
    ],
    "chicomukeltec": [
        1561
    ],
    "chicomulcelteco": [
        1561
    ],
    "cocopa": [
        1562
    ],
    "cocopah": [
        1562
    ],
    "cocopá": [
        1562
    ],
    "cucapá": [
        1562
    ],
    "cucupá": [
        1562
    ],
    "cocama": [
        1563
    ],
    "cocama-cocamilla": [
        1563
    ],
    "chʉʼo": [
        1564
    ],
    "caquetá": [
        1564
    ],
    "chaocha pai": [
        1564
    ],
    "chaocha": [
        1564
    ],
    "coreguaja": [
        1564
    ],
    "coreguaje": [
        1564
    ],
    "coreguaxe": [
        1564
    ],
    "correguaje": [
        1564
    ],
    "colorado": [
        4819,
        1565,
        6298,
        8023,
        8927
    ],
    "chong": [
        1566,
        6570
    ],
    "chawng": [
        1566
    ],
    "chuang": [
        1566,
        8966,
        8967,
        8968
    ],
    "chichonyi-chidzihana-chikauma": [
        1567
    ],
    "chonyi": [
        1567
    ],
    "chonyi-dzihana-kauma": [
        1567
    ],
    "conyi": [
        1567
    ],
    "cochimi": [
        1568
    ],
    "cadegomeño": [
        1568
    ],
    "cadegomo": [
        1568
    ],
    "cochetimi": [
        1568
    ],
    "cochima": [
        1568
    ],
    "cochimtee": [
        1568
    ],
    "cochimí": [
        1568,
        1851
    ],
    "cora, santa teresa": [
        1569
    ],
    "cora": [
        1569,
        1615
    ],
    "columbia-wenatchi": [
        1570
    ],
    "chelan": [
        1570
    ],
    "columbian": [
        1570
    ],
    "comanche": [
        1571
    ],
    "cofán": [
        1572
    ],
    "comox": [
        1573
    ],
    "comox-sliammon": [
        1573
    ],
    "coptic": [
        1574,
        1575,
        1576
    ],
    "coquille": [
        1577
    ],
    "chasta costa": [
        1577
    ],
    "chasta": [
        1577
    ],
    "costa-coquille": [
        1577
    ],
    "caquinte": [
        1578
    ],
    "caquinte campa": [
        1578
    ],
    "campa": [
        1585,
        1578
    ],
    "cogniagui": [
        1579
    ],
    "conhague": [
        1579
    ],
    "coniagui": [
        1579
    ],
    "cao miao": [
        1580
    ],
    "cao": [
        1580,
        4877
    ],
    "cowlitz": [
        1581
    ],
    "chocholtec": [
        1583
    ],
    "chocho": [
        1583
    ],
    "chocholteco": [
        1583
    ],
    "chochon": [
        1583
    ],
    "chochonteco": [
        1583
    ],
    "chochotec": [
        1583
    ],
    "chinantec, palantla": [
        1584
    ],
    "chinanteco de san pedro tlatepuzco": [
        1584
    ],
    "cappadocian greek": [
        1587
    ],
    "cappadocian": [
        1587
    ],
    "chinese pidgin english": [
        1588
    ],
    "china coast pidgin": [
        1588
    ],
    "cherepon": [
        1589
    ],
    "chiripon": [
        1589
    ],
    "chiripong": [
        1589
    ],
    "capiznon": [
        1591
    ],
    "capisano": [
        1591
    ],
    "capiseño": [
        1591
    ],
    "capizeño": [
        1591
    ],
    "chinese, pu-xian": [
        1593
    ],
    "chuanqiandian": [
        1595
    ],
    "chuanchientien miao": [
        1595
    ],
    "chuanchientien": [
        1595
    ],
    "chuanqiandian cluster miao": [
        1595
    ],
    "chuanqiandian miao": [
        1595
    ],
    "core farwestern hmongic": [
        1595
    ],
    "core": [
        1595
    ],
    "cree": [
        1596,
        1597,
        1608,
        1609,
        1610,
        1611,
        1612,
        1613,
        1614,
        1652,
        5865,
        5866,
        1603
    ],
    "cree, woods": [
        1596,
        1597
    ],
    "cri des bois": [
        1596,
        1597
    ],
    "cri": [
        1596,
        1597,
        1608,
        1609,
        1610,
        1611,
        1612,
        1613,
        1614,
        1652
    ],
    "craig cove": [
        1600
    ],
    "craig": [
        1600
    ],
    "cove": [
        1600
    ],
    "coeur d’alene": [
        1601
    ],
    "coeur": [
        1601
    ],
    "coeur d'alene": [
        1601
    ],
    "crimean tatar": [
        1604,
        1605,
        1606
    ],
    "crimean": [
        1604,
        1605,
        1606
    ],
    "crimean turkish": [
        1604,
        1605,
        1606
    ],
    "cree, southern east": [
        1608,
        1609
    ],
    "cri du sud-est": [
        1608,
        1609
    ],
    "cree, plains": [
        1610,
        1611
    ],
    "cri des plaines": [
        1610,
        1611
    ],
    "cree, northern east": [
        1612,
        1613
    ],
    "cri du nord-est": [
        1612,
        1613
    ],
    "cree, moose": [
        1614
    ],
    "cri de moose": [
        1614
    ],
    "cora, el nayar": [
        1615
    ],
    "cora de el nayar": [
        1615
    ],
    "cora tereseño": [
        1615
    ],
    "crow": [
        1616
    ],
    "chorote, iyo’wujwa": [
        1617
    ],
    "chorote": [
        1617,
        1620
    ],
    "choroti": [
        1617,
        1620
    ],
    "carolina algonquian": [
        1618
    ],
    "carolina": [
        1618
    ],
    "chorote, iyojwa’ja": [
        1620
    ],
    "chaura": [
        1621
    ],
    "chowra": [
        1621
    ],
    "chauro": [
        1622
    ],
    "cho ro": [
        1622
    ],
    "choro": [
        1622
    ],
    "central carrier": [
        1623,
        1624
    ],
    "chori": [
        1625
    ],
    "cori": [
        1625
    ],
    "cruzeño": [
        1626
    ],
    "chumash": [
        1626,
        3226,
        6373
    ],
    "chumasha proper": [
        1626,
        3226,
        6373
    ],
    "chumasha": [
        1626,
        3226,
        6373
    ],
    "chumashan": [
        1626
    ],
    "czech": [
        1627,
        1628,
        1633,
        1715
    ],
    "cehă": [
        1627,
        1628
    ],
    "cz": [
        1627,
        1628,
        1633,
        1715
    ],
    "czech republic": [
        1627,
        1628,
        1633,
        1715
    ],
    "chinantec, chiltepec": [
        1629
    ],
    "chiltepec": [
        1629
    ],
    "chiltepec chinantec": [
        1629
    ],
    "cashubian": [
        1630
    ],
    "cassubian": [
        1630
    ],
    "catalan sign language": [
        1631
    ],
    "csl": [
        1631,
        1647,
        1653
    ],
    "catalonian sign language": [
        1631
    ],
    "catalana": [
        1631
    ],
    "chiangmai sign language": [
        1632
    ],
    "chiangmai": [
        1632
    ],
    "chiengmai sign language": [
        1632
    ],
    "chiengmai": [
        1632
    ],
    "chiang": [
        1632
    ],
    "czech sign language": [
        1633
    ],
    "czj": [
        1633
    ],
    "cuban sign language": [
        1634
    ],
    "cuban": [
        1634
    ],
    "cuba sign language": [
        1634
    ],
    "cubana": [
        1634
    ],
    "cubanas": [
        1634
    ],
    "cu": [
        3791,
        1634,
        2266,
        4531
    ],
    "chilean sign language": [
        1635
    ],
    "chilean": [
        1635
    ],
    "chilena": [
        1635
    ],
    "chileno": [
        1635
    ],
    "chin, asho": [
        1636,
        1637
    ],
    "coast miwok": [
        1638
    ],
    "chin, songlai": [
        1639
    ],
    "casa": [
        1640
    ],
    "chinese sign language": [
        1641
    ],
    "central sierra miwok": [
        1642
    ],
    "colombian sign language": [
        1643
    ],
    "colombian": [
        1643
    ],
    "colombiana": [
        1643
    ],
    "chinantec, sochiapam": [
        1644
    ],
    "chinanteco del oeste": [
        1644
    ],
    "croatian sign language": [
        1647
    ],
    "croatia sign language": [
        1647
    ],
    "costa rican sign language": [
        1648
    ],
    "costaricenses": [
        1648
    ],
    "costarricense": [
        1648
    ],
    "chin, sumtu": [
        1651
    ],
    "cumtu": [
        1651
    ],
    "cree, swampy": [
        1652
    ],
    "cri des marais": [
        1652
    ],
    "cambodian sign language": [
        1653
    ],
    "cbdsl": [
        1653
    ],
    "cambodia sign language": [
        1653
    ],
    "chin, siyin": [
        1654
    ],
    "coos": [
        1655
    ],
    "chatino, tataltepec": [
        1656
    ],
    "chatino occidental bajo": [
        1656
    ],
    "chetco": [
        1657
    ],
    "chin, tedim": [
        1658,
        1659
    ],
    "chinantec, tepinapa": [
        1660
    ],
    "chinanteco del sureste medio": [
        1660
    ],
    "chittagonian": [
        1661,
        1662,
        1663
    ],
    "chatgaiyan buli": [
        1661,
        1662,
        1663
    ],
    "chatgaiyan": [
        1661,
        1662,
        1663
    ],
    "chatgaya": [
        1661,
        1662,
        1663
    ],
    "chittagonian bengali": [
        1661,
        1662,
        1663
    ],
    "chin, thaiphum": [
        1664
    ],
    "chinantec, tlacoatzintepec": [
        1665
    ],
    "chinanteco del noroeste": [
        1665
    ],
    "chitimacha": [
        1666
    ],
    "chetemacha": [
        1666
    ],
    "chhintang": [
        1667
    ],
    "chhintange": [
        1667
    ],
    "chintang": [
        1667
    ],
    "chintang rûng": [
        1667
    ],
    "catio": [
        1668
    ],
    "catío": [
        1668
    ],
    "catío emberá": [
        1668
    ],
    "chatino, western highland": [
        1669
    ],
    "chatino central": [
        1669
    ],
    "chatino de la zona alta occidental": [
        1669
    ],
    "cha’t-an": [
        1669
    ],
    "chetti, wayanad": [
        1671
    ],
    "chetti": [
        1671,
        1675
    ],
    "chetty": [
        1671,
        1675
    ],
    "chol": [
        1672,
        1673,
        1674
    ],
    "chol - tila": [
        1673
    ],
    "chol - tumala": [
        1674
    ],
    "chetti, moundadan": [
        1675
    ],
    "chatino, zacatepec": [
        1676
    ],
    "chatino de san marcos zacatepec": [
        1676
    ],
    "chatino de zacatepec": [
        1676
    ],
    "church": [
        1677,
        1678,
        1679
    ],
    "church slavic": [
        1677,
        1678,
        1679
    ],
    "church slavonic": [
        1677,
        1678,
        1679
    ],
    "cua": [
        1680,
        7874
    ],
    "cubeo": [
        1681
    ],
    "cobewa": [
        1681
    ],
    "cubeu": [
        1681
    ],
    "cuveo": [
        1681
    ],
    "chinantec, usila": [
        1682
    ],
    "chinanteco del oeste central alto": [
        1682
    ],
    "chungmboko": [
        1683
    ],
    "cung": [
        1683,
        1694
    ],
    "chuka": [
        1684
    ],
    "chuku": [
        1684
    ],
    "cuka": [
        1684
    ],
    "cuiba": [
        1685
    ],
    "cuiba-wámonae": [
        1685
    ],
    "cuiva": [
        1685
    ],
    "cujareno": [
        1686
    ],
    "cujareño": [
        1686
    ],
    "cuna": [
        1687,
        4058
    ],
    "corina": [
        1688
    ],
    "culina": [
        1688,
        8597
    ],
    "cumanagoto": [
        1689
    ],
    "cumanagota": [
        1689
    ],
    "cumanogota": [
        1689
    ],
    "cumaná": [
        1689
    ],
    "cupeño": [
        1690
    ],
    "cun": [
        1691
    ],
    "cun-hua": [
        1691
    ],
    "cunhua": [
        1691
    ],
    "chhulung": [
        1692
    ],
    "chhiling": [
        1692
    ],
    "chhilling": [
        1692
    ],
    "chholung": [
        1692
    ],
    "chhûlûng rûng": [
        1692
    ],
    "chhûlûng": [
        1692
    ],
    "chiling": [
        1692
    ],
    "chulung": [
        1692
    ],
    "chülüng": [
        1692
    ],
    "cuicatec, teutila": [
        1693
    ],
    "cuicatec": [
        1693,
        1697
    ],
    "cuvok": [
        1695
    ],
    "cuvakw": [
        1695
    ],
    "chukwa": [
        1696
    ],
    "chukuwa": [
        1696
    ],
    "cukwa ring": [
        1696
    ],
    "cukwa": [
        1696
    ],
    "cuicatec, tepeuxila": [
        1697
    ],
    "cuicateco del centro": [
        1697
    ],
    "cuicateco": [
        1697
    ],
    "centro": [
        1697,
        4594,
        5220,
        5456,
        6056,
        7318,
        7669
    ],
    "cuitlatec": [
        1698
    ],
    "chuvash": [
        1699
    ],
    "chug": [
        1700,
        1701
    ],
    "chug monpa": [
        1700,
        1701
    ],
    "chugpa": [
        1700,
        1701
    ],
    "chinantec, valle nacional": [
        1702
    ],
    "chinanteco central bajo": [
        1702
    ],
    "chwambo": [
        1704
    ],
    "cheq wong": [
        1706
    ],
    "cheq": [
        1706
    ],
    "ceq wong": [
        1706
    ],
    "ceq": [
        1706
    ],
    "che wong": [
        1706
    ],
    "chewong": [
        1706
    ],
    "che’wong": [
        1706
    ],
    "chuba": [
        1706
    ],
    "cymraeg": [
        1708,
        1709
    ],
    "chatino, nopala": [
        1710
    ],
    "chatino oriental bajo": [
        1710
    ],
    "cayubaba": [
        1711
    ],
    "cayuvava": [
        1711
    ],
    "cayuwaba": [
        1711
    ],
    "cuyonon": [
        1712
    ],
    "cuyo": [
        1712
    ],
    "cuyono": [
        1712
    ],
    "cuyunon": [
        1712
    ],
    "chinese, huizhou": [
        1713,
        1714
    ],
    "chatino, zenzontepec": [
        1716
    ],
    "chatino occidental alto": [
        1716
    ],
    "chinese, min zhong": [
        1717
    ],
    "central fujian": [
        1717
    ],
    "central min": [
        1717
    ],
    "chin, zotung": [
        1718
    ],
    "chin, daai": [
        1734,
        1735,
        1736,
        1737,
        1738
    ],
    "chin, kheng daai": [
        1735
    ],
    "chin, daai matupi licang": [
        1736
    ],
    "chin, daai matupi tuivang": [
        1737
    ],
    "chin, yindu daar": [
        1738
    ],
    "creool": [
        1770
    ],
    "cez": [
        1778
    ],
    "ch": [
        1786,
        2137,
        2429,
        2795,
        3262,
        6331,
        6539,
        6556,
        6811,
        6944,
        7146,
        8152
    ],
    "chutiya": [
        1808,
        1809
    ],
    "casiguran": [
        1815
    ],
    "casiguran agta": [
        1815
    ],
    "casiguran dumagat": [
        1815
    ],
    "casiguran dumagat agta": [
        1815
    ],
    "chimba": [
        1836
    ],
    "central dinka": [
        1846
    ],
    "chidigo": [
        1850
    ],
    "comeya": [
        1851
    ],
    "cuchimí": [
        1851
    ],
    "chungki": [
        1875
    ],
    "chunkumberries": [
        1875
    ],
    "chunkunburra": [
        1875
    ],
    "central grand valley dani": [
        1925
    ],
    "calão de minde": [
        1955
    ],
    "calão": [
        1955,
        6558
    ],
    "charales": [
        1955
    ],
    "c’lela": [
        1959
    ],
    "c'lela": [
        1959
    ],
    "cala-cala": [
        1959
    ],
    "chilala": [
        1959,
        4267
    ],
    "chilela": [
        1959
    ],
    "cˀlela": [
        1959
    ],
    "central dusun": [
        1989
    ],
    "central kadazan": [
        1989
    ],
    "chiduruma": [
        2000
    ],
    "check-cull": [
        2043
    ],
    "chewlie": [
        2043
    ],
    "central teke": [
        2054,
        5819
    ],
    "cama": [
        2055
    ],
    "caman": [
        2055
    ],
    "calabar": [
        2066
    ],
    "central yambassa": [
        2084,
        4920,
        8741
    ],
    "coti": [
        2085,
        2086
    ],
    "chocó": [
        2109,
        5618
    ],
    "cholo": [
        2109,
        6889,
        7385
    ],
    "chugach eskimo": [
        2111,
        2112
    ],
    "chugach": [
        2111,
        2112
    ],
    "caló": [
        6558,
        2115
    ],
    "caló vasco": [
        2115
    ],
    "canadian english": [
        2135
    ],
    "canadian": [
        3178,
        2135,
        3281,
        3186,
        3187
    ],
    "cc": [
        2136,
        5071
    ],
    "cocos (keeling) islands": [
        2136,
        5071
    ],
    "ck": [
        2138,
        6175,
        6229,
        6472,
        6534
    ],
    "cook islands": [
        2138,
        6175,
        6229,
        6472,
        6534
    ],
    "cook": [
        6472,
        2138,
        6175,
        6229,
        6534
    ],
    "cx": [
        2140
    ],
    "christmas island": [
        2140
    ],
    "christmas": [
        2140
    ],
    "cayman islands": [
        2172
    ],
    "cayman": [
        2172
    ],
    "cunha": [
        2204
    ],
    "caicos": [
        7362,
        2211
    ],
    "caga": [
        2237
    ],
    "castellano": [
        2256,
        2262,
        2268,
        7061
    ],
    "castilian": [
        2256,
        2257,
        2258,
        2259,
        2260,
        2261,
        2262,
        2263,
        2264,
        2265,
        2266,
        2267,
        2268,
        2269,
        2270,
        2271,
        2272,
        2273,
        2274,
        2275,
        2276,
        2277,
        2278,
        2279,
        2280,
        2281,
        2282,
        2283,
        2284,
        2285
    ],
    "castillan": [
        2256,
        2262,
        2268
    ],
    "ceuta, melilla": [
        2269
    ],
    "ceuta": [
        2269
    ],
    "canary islands": [
        2274
    ],
    "canary": [
        2274
    ],
    "central siberian yupik": [
        2297,
        2298
    ],
    "central alaskan yupik": [
        2299
    ],
    "central yupik": [
        2299
    ],
    "chapogir": [
        2320,
        2321,
        2322
    ],
    "cahtúo": [
        2324
    ],
    "cahtúö": [
        2324
    ],
    "canadiens": [
        2350
    ],
    "cifipa": [
        2389
    ],
    "chikabanga": [
        2406
    ],
    "canadien": [
        2425
    ],
    "cajun": [
        2466
    ],
    "cajan": [
        2466
    ],
    "cajun french": [
        2466
    ],
    "cadien": [
        2466
    ],
    "carnijó": [
        2492
    ],
    "central-eastern niger fulfulde": [
        2493
    ],
    "chinese, gan": [
        2523,
        2524,
        2525
    ],
    "cabee": [
        2561
    ],
    "carby": [
        2561
    ],
    "carby-carbery": [
        2561
    ],
    "colonia": [
        2572
    ],
    "coloniero": [
        2572
    ],
    "colonia tovar german": [
        2572
    ],
    "chitodi lohar": [
        2574
    ],
    "chitodi": [
        2574
    ],
    "chittoriya lohar": [
        2574
    ],
    "chittoriya": [
        2574
    ],
    "cheke": [
        5053,
        2579
    ],
    "carinthian german": [
        2603
    ],
    "cape draping gelao": [
        2650
    ],
    "cape": [
        2650,
        3558,
        7371,
        8483,
        8862,
        6332
    ],
    "children’s": [
        2664
    ],
    "cangoolootha": [
        2714
    ],
    "curang-gurang": [
        2718
    ],
    "curanggurang": [
        2718
    ],
    "chigogo": [
        2730
    ],
    "cigogo": [
        2730
    ],
    "chuala": [
        2758
    ],
    "chilao": [
        2760
    ],
    "central grebo": [
        2782
    ],
    "coconuco": [
        2814
    ],
    "cunimía": [
        2816
    ],
    "cobari kobali": [
        2822
    ],
    "cobari": [
        2822
    ],
    "cobariwa": [
        2822
    ],
    "cashquiha": [
        2827
    ],
    "cooyiannie": [
        2840
    ],
    "cuini": [
        2855
    ],
    "central guéré": [
        2857
    ],
    "chiriqui": [
        2865
    ],
    "creolese": [
        2866
    ],
    "chapacura": [
        2868
    ],
    "chinese, hakka": [
        2893,
        2894,
        2895
    ],
    "chobba": [
        2912
    ],
    "chibito": [
        2938
    ],
    "chirechire": [
        2950
    ],
    "chuwau": [
        2950
    ],
    "chware": [
        2950
    ],
    "chawiyana": [
        2954
    ],
    "chin, matu": [
        2968
    ],
    "central songai": [
        2971
    ],
    "central huishui hmong": [
        2972
    ],
    "central huishui miao": [
        2972
    ],
    "chonganjiang miao": [
        2981
    ],
    "chonganjiang": [
        2981
    ],
    "central mashan hmong": [
        2984
    ],
    "central mashan miao": [
        2984
    ],
    "central miao": [
        2986,
        2989,
        2991
    ],
    "chientung miao": [
        2986,
        2989,
        2991
    ],
    "chientung": [
        2986,
        2989,
        2991
    ],
    "changshu miao": [
        2997,
        2998
    ],
    "changshu": [
        2997,
        2998
    ],
    "curved comb miao": [
        2997,
        2998
    ],
    "curved": [
        2997,
        2998
    ],
    "comb": [
        2997,
        2998
    ],
    "chhattisgarhi": [
        3001
    ],
    "ching miao": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "ching": [
        3005,
        3006,
        3007,
        3008,
        3009,
        4852,
        8078,
        8079,
        8080
    ],
    "caribbean bharatiya": [
        3013
    ],
    "caribbean hindi": [
        3013
    ],
    "caribbean hindustani": [
        3013
    ],
    "caribbean urdu": [
        3013
    ],
    "cuói": [
        3014
    ],
    "chi": [
        3034,
        4235,
        4824,
        4877
    ],
    "city": [
        3034,
        3264,
        4185,
        5262
    ],
    "cham-re": [
        3047,
        3048
    ],
    "chom": [
        3047,
        3048
    ],
    "changjiao miao": [
        3050
    ],
    "changjiao": [
        3050
    ],
    "chinese, xiang": [
        3061,
        3062
    ],
    "créole haïtien": [
        3064
    ],
    "central witoto proper": [
        3090
    ],
    "culture": [
        3096
    ],
    "central ifugao": [
        3145
    ],
    "central-western ijo": [
        3172
    ],
    "central-western": [
        3172
    ],
    "canadian inuit": [
        3178,
        3281
    ],
    "chiila": [
        3193
    ],
    "chensu": [
        3241,
        3242
    ],
    "chomharthaíochta": [
        3250
    ],
    "camucones": [
        3266,
        5710
    ],
    "chekiri": [
        3274
    ],
    "chirin nu ibatan": [
        3289
    ],
    "chirin": [
        3289
    ],
    "canamanti": [
        3305
    ],
    "coobenpil": [
        3316
    ],
    "caledonian": [
        3319
    ],
    "country sign": [
        3336
    ],
    "country": [
        3336
    ],
    "chebero": [
        3344
    ],
    "celle": [
        3349
    ],
    "cú-mbɔ́ndaa": [
        3359
    ],
    "cú-ŋgɔmbaa": [
        3359
    ],
    "chingalee": [
        3367
    ],
    "chunguloo": [
        3367
    ],
    "chicham": [
        3376
    ],
    "chiwaro": [
        3376
    ],
    "cheju": [
        3378
    ],
    "chejumal": [
        3378
    ],
    "cheycwu": [
        3378
    ],
    "cheycwumal": [
        3378
    ],
    "central nepali": [
        3394
    ],
    "coicoyán mixtec": [
        3399
    ],
    "coicoyán": [
        3399
    ],
    "central kinnauri": [
        3400,
        6737,
        7139
    ],
    "cho rai": [
        3419,
        3420
    ],
    "cho-rai": [
        3419,
        3420
    ],
    "chor": [
        3419,
        3420
    ],
    "chrai": [
        3419,
        3420
    ],
    "chakato": [
        3423
    ],
    "caribbean javanese": [
        3447
    ],
    "chiarong": [
        3449
    ],
    "common kartvelian": [
        3452,
        3453,
        3454
    ],
    "common": [
        3452,
        3453,
        3454,
        7017,
        7018,
        7022
    ],
    "chingpaw": [
        3461
    ],
    "chingp’o": [
        3461
    ],
    "capanahua": [
        3473
    ],
    "capa baquebo": [
        3473
    ],
    "capa": [
        3473,
        6396
    ],
    "capabaquebo": [
        3473
    ],
    "capanawa": [
        3473
    ],
    "catuquina": [
        3474,
        3840
    ],
    "camaiura": [
        3477
    ],
    "caxuiana": [
        3479
    ],
    "cadiuéu": [
        3480
    ],
    "caduvéo": [
        3480
    ],
    "camsá": [
        3484
    ],
    "camëntsá": [
        3484
    ],
    "camëntxá": [
        3484
    ],
    "coche": [
        3484
    ],
    "cabrai": [
        3492,
        3493
    ],
    "cabrais": [
        3492,
        3493
    ],
    "cobiana": [
        3515
    ],
    "chikalanga": [
        3516
    ],
    "ciket": [
        3527
    ],
    "chimakonde": [
        3535
    ],
    "chinimakonde": [
        3535
    ],
    "cimakonde": [
        3535
    ],
    "cotocoli": [
        3538,
        3539
    ],
    "chicunda": [
        3545
    ],
    "chikunda": [
        3545
    ],
    "cikunda": [
        3545
    ],
    "cuoi": [
        3550,
        3551,
        3552,
        7654
    ],
    "caboverdiano": [
        3558
    ],
    "cape verdean creole": [
        3558
    ],
    "criol": [
        3558
    ],
    "crioulo": [
        3558,
        3813,
        6264
    ],
    "cv": [
        3558,
        6332
    ],
    "cape verde": [
        3558,
        6332
    ],
    "cacche’": [
        3568
    ],
    "cacché": [
        3568
    ],
    "coorg": [
        3586
    ],
    "coorgi kodava": [
        3586
    ],
    "coorgi": [
        3586
    ],
    "canarese": [
        3598,
        3599,
        3818,
        3819,
        3820
    ],
    "cungo": [
        3603
    ],
    "cuchi": [
        3609,
        3610
    ],
    "cutch": [
        3609,
        3610
    ],
    "cutchi": [
        3609,
        3610
    ],
    "caingua": [
        3628
    ],
    "caiua": [
        3628
    ],
    "caiwa": [
        3628
    ],
    "cayua": [
        3628
    ],
    "coongurri": [
        3629
    ],
    "caingang": [
        3633
    ],
    "caingangue": [
        3633
    ],
    "coroado": [
        3633,
        6298
    ],
    "coroados": [
        3633
    ],
    "cossyah": [
        3643,
        3644
    ],
    "chiini": [
        3659
    ],
    "ciini": [
        3659
    ],
    "chitrali": [
        3666
    ],
    "chitrari": [
        3666
    ],
    "citrali": [
        3666
    ],
    "cáuigù": [
        3683
    ],
    "cáuijò:gyà": [
        3683
    ],
    "cáuijògà": [
        3683
    ],
    "cuanhama": [
        3694,
        3695
    ],
    "conob": [
        3697,
        3827
    ],
    "coastal konjo": [
        3698
    ],
    "cam mu": [
        3702,
        3703,
        3704
    ],
    "chaman": [
        3702,
        3703,
        3704,
        9110
    ],
    "cau": [
        3702,
        3703,
        3704
    ],
    "chamang boli": [
        3712
    ],
    "chamang": [
        3712
    ],
    "chikagulu": [
        3744
    ],
    "chimegi": [
        3744
    ],
    "cikagulu": [
        3744
    ],
    "chikuya": [
        3759
    ],
    "cikuya": [
        3759
    ],
    "caska": [
        3762
    ],
    "camileroi": [
        3767
    ],
    "chaladsch": [
        3773
    ],
    "central khmer": [
        3791
    ],
    "cu tho": [
        3791
    ],
    "cur cul": [
        3791
    ],
    "cur": [
        3791
    ],
    "cul": [
        4345,
        3791
    ],
    "central kankanaey": [
        3824
    ],
    "canamarí": [
        3831
    ],
    "central konkan": [
        3832,
        3833,
        3861
    ],
    "concorinum": [
        3832,
        3833,
        3861
    ],
    "cugani": [
        3832,
        3833,
        3861
    ],
    "chaoxian": [
        3847,
        3848,
        3850
    ],
    "chaoxianyu": [
        3847,
        3848,
        3850
    ],
    "chaoyu": [
        3847,
        3848,
        3850
    ],
    "cagaba": [
        3856
    ],
    "coghui": [
        3856
    ],
    "cogui": [
        3856
    ],
    "curripaco": [
        3875
    ],
    "coripaco": [
        3875
    ],
    "cumata": [
        3875
    ],
    "curipaco": [
        3875
    ],
    "curripaco-baniva": [
        3875
    ],
    "caraiauna": [
        3883
    ],
    "carajá": [
        3883
    ],
    "chambioa": [
        3883
    ],
    "caho": [
        3886
    ],
    "co ho": [
        3886
    ],
    "coho": [
        3886
    ],
    "chikahonde": [
        3911
    ],
    "chikaonde": [
        3911
    ],
    "crenac": [
        3914
    ],
    "crenaque": [
        3914
    ],
    "central kanuri": [
        3925,
        3926
    ],
    "cairui": [
        3930
    ],
    "convet": [
        3945
    ],
    "cashmeeree": [
        3950,
        3951,
        3952,
        3953
    ],
    "cashmiri": [
        3950,
        3951,
        3952,
        3953
    ],
    "casiguranin": [
        3967
    ],
    "ca tua": [
        3981
    ],
    "caritiana": [
        3995
    ],
    "commercial": [
        4001
    ],
    "cahto": [
        4003
    ],
    "caxarari": [
        4004
    ],
    "chimbu": [
        4018,
        7149
    ],
    "chong’e": [
        4021
    ],
    "calapalu": [
        4022
    ],
    "cuicuro": [
        4022
    ],
    "cuicutl": [
        4022
    ],
    "cunama": [
        4029
    ],
    "caripuna": [
        4032
    ],
    "caiman nuevo": [
        4058
    ],
    "caiman": [
        4058
    ],
    "colombia cuna": [
        4058
    ],
    "curnoack": [
        4072
    ],
    "coaiquer": [
        4081
    ],
    "cuaiquer": [
        4081
    ],
    "cuangar": [
        4086
    ],
    "cuanhoca": [
        4097
    ],
    "cuepe": [
        4097
    ],
    "curoca": [
        4097
    ],
    "central murut": [
        4108
    ],
    "canoé": [
        4114
    ],
    "canoê": [
        4114
    ],
    "ca giong": [
        4127
    ],
    "cɛŋɛ": [
        4148
    ],
    "cenge": [
        4148
    ],
    "caravare": [
        4149
    ],
    "curuaia": [
        4149
    ],
    "caiabí": [
        4161
    ],
    "caeli": [
        4171
    ],
    "cajeli": [
        4171
    ],
    "cariri": [
        4181
    ],
    "cudeo-espanyol": [
        4189,
        4190,
        4191
    ],
    "chamba lahuli": [
        4192,
        4193
    ],
    "changsapa boli": [
        4192,
        4193
    ],
    "changsapa": [
        4192,
        4193
    ],
    "chilambya": [
        4201
    ],
    "chilamba": [
        4205
    ],
    "chashan yao": [
        4220
    ],
    "chashan": [
        4220,
        4495
    ],
    "cu-tê": [
        4235
    ],
    "cù te": [
        4235
    ],
    "cù": [
        4235
    ],
    "chiluchazi": [
        4246
    ],
    "cujazi": [
        4246
    ],
    "chi-luchazi": [
        4246
    ],
    "cocoli": [
        4261
    ],
    "cibbo": [
        4264
    ],
    "cuyi tsó": [
        4264
    ],
    "cuyi": [
        4264
    ],
    "chilenje": [
        4272
    ],
    "chinamukuni": [
        4272
    ],
    "ciina": [
        4272
    ],
    "ciina mukuni": [
        4272
    ],
    "chien": [
        4313
    ],
    "central ambon": [
        4314
    ],
    "central lisu": [
        4341,
        4342,
        4471,
        4472
    ],
    "chedi": [
        4341,
        4342
    ],
    "cheli": [
        4341,
        4342
    ],
    "col": [
        4345,
        8504
    ],
    "cosung": [
        4359
    ],
    "central rote": [
        4380,
        7835
    ],
    "coastal saluan": [
        4443
    ],
    "créole louisianais": [
        4461
    ],
    "chashanhua": [
        4495
    ],
    "chit": [
        4495
    ],
    "ciluba": [
        4518
    ],
    "chiluvale": [
        4521
    ],
    "cham’teela": [
        4523
    ],
    "chiluimbi": [
        4527
    ],
    "chilunda": [
        4528
    ],
    "chin, mizo": [
        4533,
        4534,
        4535
    ],
    "chhathare": [
        4537
    ],
    "cea": [
        4537,
        8750
    ],
    "ca-luiana": [
        4563
    ],
    "chan": [
        4568,
        4569,
        4570
    ],
    "chanuri": [
        4568,
        4569,
        4570
    ],
    "chanzan": [
        4568,
        4569,
        4570
    ],
    "chiquihuitlán": [
        4590
    ],
    "chiquihuitlán mazatec": [
        4590
    ],
    "central mazahua": [
        4599
    ],
    "chinese malay": [
        4605
    ],
    "caposho": [
        4610
    ],
    "cumanasho": [
        4610
    ],
    "cunuana": [
        4632
    ],
    "chimbunda": [
        4635
    ],
    "chimbúùnda": [
        4635
    ],
    "cristao": [
        4637
    ],
    "coatlán": [
        4639,
        9138,
        9139
    ],
    "coatlán mixe": [
        4639
    ],
    "cameroon mambila": [
        4645
    ],
    "central melanau": [
        4690
    ],
    "creolophone": [
        4712
    ],
    "cross": [
        4723
    ],
    "cross river mbembe": [
        4723
    ],
    "chimakua": [
        4747
    ],
    "chubo": [
        4754
    ],
    "chimatengo": [
        4762
    ],
    "cellate": [
        4771
    ],
    "croker": [
        4773
    ],
    "cusso": [
        4786
    ],
    "chalcatongo mixtec": [
        4798
    ],
    "chalcatongo": [
        4798
    ],
    "chayuco": [
        4799
    ],
    "chayuco mixtec": [
        4799
    ],
    "chayucu": [
        4799
    ],
    "chigmecatitlán": [
        4800
    ],
    "central puebla mixtec": [
        4800
    ],
    "chigmecatitlán mixtec": [
        4800
    ],
    "central misteko": [
        4804
    ],
    "coastal mixtec": [
        4807
    ],
    "cacaloxtepec": [
        4813
    ],
    "cacaloxtepec mixtec": [
        4813
    ],
    "coastal guerrero mixtec": [
        4816
    ],
    "coatzospan": [
        4817
    ],
    "coatzospan mixtec": [
        4817
    ],
    "coatzóspan": [
        4817
    ],
    "concow": [
        4820
    ],
    "chasan yao": [
        4824
    ],
    "chasan": [
        4824
    ],
    "coc mun": [
        4824
    ],
    "coc": [
        4824
    ],
    "chip": [
        4835
    ],
    "cip": [
        4835
    ],
    "chau pok": [
        4858
    ],
    "chau": [
        4858,
        5193,
        5194,
        7865,
        7866,
        8923,
        8924,
        8925,
        8926
    ],
    "cinamiguin": [
        4869
    ],
    "cinamiguin manobo": [
        4869
    ],
    "cao lan": [
        4877
    ],
    "caolan": [
        4877
    ],
    "chay": [
        4877
    ],
    "conta-reddi": [
        4911
    ],
    "central mongolian": [
        4926,
        4927,
        4929,
        4931,
        4932
    ],
    "chinese, min bei": [
        4950
    ],
    "chorotega": [
        4969
    ],
    "cunausaya": [
        4976
    ],
    "chakwar": [
        4978
    ],
    "chukwar": [
        4978
    ],
    "chinyasa": [
        4984
    ],
    "chimpoto": [
        4984
    ],
    "cimpoto": [
        4984
    ],
    "cim": [
        5028
    ],
    "chir": [
        5029
    ],
    "cocomaricopa": [
        5041
    ],
    "chin, mara": [
        5048
    ],
    "ceta": [
        5050
    ],
    "cheke holo": [
        5053
    ],
    "cheke tahati": [
        5053
    ],
    "central margi": [
        5060
    ],
    "chican sign language": [
        5076
    ],
    "chican": [
        5076
    ],
    "chicana": [
        5076
    ],
    "caac": [
        5089
    ],
    "caaac": [
        5089
    ],
    "caawac": [
        5089
    ],
    "cotabato": [
        5101
    ],
    "cotabato manobo": [
        5101
    ],
    "copper island aleut": [
        5129
    ],
    "copper island attuan": [
        5129
    ],
    "creolized attuan": [
        5129
    ],
    "creolized": [
        5129
    ],
    "chapu-shimi": [
        5130
    ],
    "chaupi-lengua": [
        5130
    ],
    "chaupi-shimi": [
        5130
    ],
    "chukkol": [
        5138
    ],
    "creek": [
        5142
    ],
    "chimwera": [
        5178
    ],
    "cimwela": [
        5178
    ],
    "cimwera": [
        5178
    ],
    "central malinke": [
        5183
    ],
    "chinamwanga": [
        5186
    ],
    "chinyamwanga": [
        5186
    ],
    "cinamwanga": [
        5186
    ],
    "central maewo": [
        5187
    ],
    "central torres strait": [
        5188
    ],
    "chin, müün": [
        5189
    ],
    "chau ko’": [
        5193,
        5194
    ],
    "chuan miao": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "chuan": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "chimanyika": [
        5207
    ],
    "cimbangala": [
        5211
    ],
    "cristobal": [
        5224
    ],
    "cochoapa": [
        5226
    ],
    "central marsela": [
        5230
    ],
    "central masela": [
        5230
    ],
    "caras-pretas": [
        5249
    ],
    "classical mandaean": [
        5254
    ],
    "classical mandaic": [
        5254
    ],
    "chosineɬ diꞌ mowi:maj": [
        5271
    ],
    "chosineɬ": [
        5271
    ],
    "chosineɬ di’ mowi:maj": [
        5271
    ],
    "chinese, min nan": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "cahungwarya": [
        5303
    ],
    "cәhungwә̀ryə̀": [
        5303
    ],
    "ca̱hungwa̱rya̱": [
        5303
    ],
    "coatepec": [
        5307
    ],
    "coatepec aztec": [
        5307
    ],
    "coatepec nahuatl": [
        5307
    ],
    "chang naga": [
        5312
    ],
    "changyanguh": [
        5312
    ],
    "central nicobarese": [
        5334,
        5335
    ],
    "central huasteca nahuatl": [
        5341
    ],
    "classical nahuatl": [
        5342
    ],
    "cane": [
        5351
    ],
    "chothe": [
        5353,
        5354
    ],
    "chawte": [
        5353,
        5354
    ],
    "chote": [
        5353,
        5354
    ],
    "chothe naga": [
        5353,
        5354
    ],
    "chowte": [
        5353,
        5354
    ],
    "chumburung": [
        5355
    ],
    "central puebla aztec": [
        5356
    ],
    "central puebla nahuatl": [
        5356
    ],
    "calebasses": [
        5360
    ],
    "chindau": [
        5361
    ],
    "cindau": [
        5361
    ],
    "chindali": [
        5365
    ],
    "cindali": [
        5365
    ],
    "chamba leeko": [
        5366
    ],
    "chamba leko": [
        5366
    ],
    "co ndogo": [
        5384
    ],
    "chilowe": [
        5431
    ],
    "cilowe": [
        5431
    ],
    "chiripá": [
        5448
    ],
    "chiripá-guaraní": [
        5448
    ],
    "cosoleacaque aztec": [
        5454
    ],
    "cosoleacaque": [
        5454
    ],
    "cuentepec": [
        5455
    ],
    "central aztec": [
        5456
    ],
    "central nahuatl": [
        5456
    ],
    "chichiquila": [
        5459
    ],
    "cemual": [
        5482
    ],
    "congo nyoro": [
        5490
    ],
    "chindonde": [
        5495
    ],
    "chindonde hamba": [
        5495
    ],
    "chizima": [
        5496
    ],
    "choimi": [
        5496
    ],
    "cholimi": [
        5502
    ],
    "cangala": [
        5524
    ],
    "chinyika": [
        5532
    ],
    "cw": [
        5541
    ],
    "curaçao": [
        5541
    ],
    "champhung": [
        5566
    ],
    "chinambya": [
        5580
    ],
    "cingindo": [
        5609
    ],
    "chanco": [
        5618
    ],
    "chocama": [
        5618
    ],
    "central wintun": [
        5629
    ],
    "chingmengu": [
        5644
    ],
    "cuendelengo": [
        5654
    ],
    "chen-kayu": [
        5658
    ],
    "chokri": [
        5669
    ],
    "chakhesang": [
        5669
    ],
    "chakhesang chokri": [
        5669
    ],
    "chakrima naga": [
        5669
    ],
    "chakrima": [
        5669
    ],
    "chakru": [
        5669
    ],
    "chokri naga": [
        5669
    ],
    "chinsenga": [
        5685
    ],
    "cinsenga": [
        5685
    ],
    "cham chang": [
        5701,
        5702,
        5703
    ],
    "combe": [
        5732
    ],
    "classical newari": [
        5758,
        5759,
        5760,
        5761,
        5762
    ],
    "classical nepal bhasa": [
        5758,
        5759,
        5760,
        5761,
        5762
    ],
    "chichewa": [
        5786,
        5787
    ],
    "chicheŵa": [
        5786,
        5787
    ],
    "chewa": [
        5786,
        5787
    ],
    "chinjanja": [
        5786,
        5787
    ],
    "chinyanja": [
        5786,
        5787
    ],
    "cinyanja": [
        5786,
        5787
    ],
    "cinianja": [
        5786,
        5787
    ],
    "cinyungwe": [
        5807
    ],
    "chinyungwe": [
        5807
    ],
    "chinyungwi": [
        5807
    ],
    "cha mbémbe": [
        5812
    ],
    "chya mbembe": [
        5812
    ],
    "chya": [
        5812
    ],
    "cya mbembe": [
        5812
    ],
    "cya": [
        5812
    ],
    "central ojibwa": [
        5863
    ],
    "central ojibwe": [
        5863
    ],
    "colville-okanagan": [
        5870,
        5871
    ],
    "cent": [
        5882,
        5884
    ],
    "chaga": [
        5892
    ],
    "chagga": [
        5892
    ],
    "cegiha": [
        5904
    ],
    "cambeba": [
        5907
    ],
    "cambeeba": [
        5907
    ],
    "cambela": [
        5907
    ],
    "campeba": [
        5907
    ],
    "campeua": [
        5907
    ],
    "canga-peba": [
        5907
    ],
    "carari": [
        5907
    ],
    "compeva": [
        5907
    ],
    "choon": [
        5920
    ],
    "coto": [
        5952
    ],
    "chavante": [
        5984,
        8409
    ],
    "cuexcontitlan": [
        5992
    ],
    "cado": [
        6018,
        6019
    ],
    "cabahyba": [
        6022,
        8240
    ],
    "cauaiua": [
        6022,
        8240
    ],
    "cauhib": [
        6022,
        8240
    ],
    "cawahib": [
        6022,
        8240
    ],
    "curassese": [
        6033
    ],
    "curaçoleño": [
        6033
    ],
    "changgars": [
        6034
    ],
    "coso": [
        6035
    ],
    "coyotepec": [
        6046
    ],
    "coyotepec popoloca": [
        6046
    ],
    "central pame": [
        6056
    ],
    "chichimeca": [
        6056,
        6096
    ],
    "chang chá": [
        6062,
        6063
    ],
    "chá": [
        6062,
        6063
    ],
    "chung cha": [
        6062,
        6063
    ],
    "chung-chia": [
        6062,
        6063
    ],
    "cùi chu": [
        6062,
        6063
    ],
    "cùi": [
        6062,
        6063
    ],
    "chti": [
        6064
    ],
    "chtimi": [
        6064
    ],
    "chin, paite": [
        6075
    ],
    "chita pardhi": [
        6076
    ],
    "chita": [
        6076
    ],
    "chinese indonesian": [
        6089
    ],
    "clear lake pomo": [
        6090
    ],
    "clear": [
        6090
    ],
    "chichimeco-jonaz": [
        6096
    ],
    "chichimec": [
        6096
    ],
    "chichimeca-jonaz": [
        6096
    ],
    "chichimeco": [
        6096
    ],
    "catang": [
        6123
    ],
    "chichineri": [
        6143
    ],
    "chontaquiro": [
        6143
    ],
    "contaquiro": [
        6143
    ],
    "chase": [
        6155
    ],
    "chɨpɨmbwe": [
        6162
    ],
    "cipimbwe": [
        6162
    ],
    "central palawano": [
        6184
    ],
    "ch’rame": [
        6209
    ],
    "congo pol": [
        6213
    ],
    "coastal pontic": [
        6241,
        6242,
        6243
    ],
    "cabanapo": [
        6259
    ],
    "central pomo": [
        6259
    ],
    "casamance creole": [
        6264
    ],
    "casamance": [
        6264
    ],
    "casamancese creole": [
        6264
    ],
    "casamancese": [
        6264
    ],
    "casamançais": [
        6264
    ],
    "crioulo de guinea-bissau": [
        6264
    ],
    "créole afro-portugais de casamance": [
        6264
    ],
    "créole casamançais": [
        6264
    ],
    "créole de casamance": [
        6264
    ],
    "chipogolo": [
        6267
    ],
    "chipogoro": [
        6267
    ],
    "cipogolo": [
        6267
    ],
    "camotes": [
        6289
    ],
    "cî": [
        6290
    ],
    "central malay": [
        6311
    ],
    "central pashto": [
        6323
    ],
    "conoy": [
        6327
    ],
    "cuminapanema": [
        6345
    ],
    "cujubi": [
        6368
    ],
    "central mixe": [
        6383
    ],
    "chuxnabán mixe": [
        6383
    ],
    "chuxnabán": [
        6383
    ],
    "cuzco": [
        6393
    ],
    "cuzco quechua": [
        6393
    ],
    "cusco": [
        6393
    ],
    "cusco-collao": [
        6393
    ],
    "central bolivian quechua": [
        6394
    ],
    "cochabamba quechua": [
        6394
    ],
    "cochabamba": [
        6394
    ],
    "central k’iche’": [
        6398
    ],
    "central quiché": [
        6398
    ],
    "chiquel": [
        6398
    ],
    "calderón": [
        6399
    ],
    "calderón highland quichua": [
        6399
    ],
    "calderón quichua": [
        6399
    ],
    "cayambe quichua": [
        6399
    ],
    "cayambe": [
        6399
    ],
    "chimborazo": [
        6401
    ],
    "central highland quichua": [
        6401
    ],
    "chimborazo highland quichua": [
        6401
    ],
    "chimborazo quichua": [
        6401
    ],
    "chachapoyas": [
        6403
    ],
    "chachapoyas quechua": [
        6403
    ],
    "chaupihuaranga": [
        6409
    ],
    "carrion": [
        6409
    ],
    "chanca": [
        6414
    ],
    "chanka": [
        6414
    ],
    "chanka runasimi": [
        6414
    ],
    "cajamarca": [
        6416
    ],
    "cajamarca quechua": [
        6416
    ],
    "cajatambo": [
        6421
    ],
    "cajatambo north lima quechua": [
        6421
    ],
    "choyo": [
        6428
    ],
    "canelos quichua": [
        6429
    ],
    "canelos": [
        6429
    ],
    "corongo": [
        6430
    ],
    "corongo ancash quechua": [
        6430
    ],
    "corongo quechua": [
        6430
    ],
    "classical quechua": [
        6431
    ],
    "chiquián": [
        6436
    ],
    "chiquián ancash quechua": [
        6436
    ],
    "chincha": [
        6437
    ],
    "chincha quechua": [
        6437
    ],
    "conchucos": [
        6440,
        6441
    ],
    "conchucos quechua": [
        6440,
        6441
    ],
    "callejon": [
        6440
    ],
    "callejón": [
        6441
    ],
    "collao": [
        6442
    ],
    "cañar": [
        6444
    ],
    "cañar highland quichua": [
        6444
    ],
    "cañar quichua": [
        6444
    ],
    "cotahuasi quechua": [
        6447
    ],
    "cotahuasi": [
        6447
    ],
    "chamling": [
        6455
    ],
    "camling": [
        6455
    ],
    "chamlinge rai": [
        6455
    ],
    "chamlinge": [
        6455
    ],
    "canela": [
        6467
    ],
    "cook islands maori": [
        6472
    ],
    "cook island": [
        6472
    ],
    "chiutse": [
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "ch’opa": [
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "créole réunionnais": [
        6490
    ],
    "canpa": [
        6508
    ],
    "chyanam": [
        6508
    ],
    "coo-al": [
        6538
    ],
    "carpathian": [
        6542,
        6619,
        6620
    ],
    "carpathian romani": [
        6542
    ],
    "central romani": [
        6542
    ],
    "chib": [
        6544
    ],
    "caló romani": [
        6558
    ],
    "chibi": [
        6558
    ],
    "chilu wunda": [
        6568
    ],
    "chilu": [
        6568
    ],
    "chiluwunda": [
        6568
    ],
    "cacgia": [
        6582
    ],
    "cacgia roglai": [
        6582
    ],
    "cigány": [
        6588,
        6590
    ],
    "chin, rungtu": [
        6605
    ],
    "carpatho-rusyn": [
        6619,
        6620
    ],
    "cilugulu": [
        6621
    ],
    "ce": [
        6625,
        7605
    ],
    "chal": [
        6630,
        6631
    ],
    "central okinawan": [
        6648
    ],
    "cisafwa": [
        6701
    ],
    "chikuahane": [
        6709
    ],
    "chikuhane": [
        6709
    ],
    "chikwahane": [
        6709
    ],
    "ciikuhane": [
        6709
    ],
    "chisoli": [
        6716
    ],
    "central sardinian": [
        6718
    ],
    "chut": [
        6719
    ],
    "chota nagpuri": [
        6726,
        6727
    ],
    "chota": [
        6726,
        6727
    ],
    "calabro-sicilian": [
        6730
    ],
    "chu’ung": [
        6733
    ],
    "cadong": [
        6777
    ],
    "cebaara": [
        6779
    ],
    "cebaara senoufo": [
        6779
    ],
    "chisena": [
        6781,
        7238
    ],
    "cisena": [
        6781,
        7238
    ],
    "cmiique iitom": [
        6782
    ],
    "cmiique": [
        6782
    ],
    "comcaac": [
        6782
    ],
    "comcáac": [
        6782
    ],
    "comcáackg": [
        6782
    ],
    "concaac": [
        6782
    ],
    "concáac": [
        6782
    ],
    "congcaac": [
        6782
    ],
    "cuncaac": [
        6782
    ],
    "central selkups": [
        6786
    ],
    "chumyl’ khumyt": [
        6786
    ],
    "chumyl’": [
        6786
    ],
    "coca": [
        6797,
        7004
    ],
    "chin, senthang": [
        6798
    ],
    "cantilangnon": [
        6809
    ],
    "cula": [
        6818
    ],
    "caning": [
        6840
    ],
    "colo": [
        6841,
        6842
    ],
    "chulla": [
        6841,
        6842
    ],
    "caliseca": [
        6850
    ],
    "chama": [
        6850
    ],
    "choa": [
        6855,
        6856
    ],
    "chad arabic": [
        6855,
        6856
    ],
    "chadian arabic": [
        6855,
        6856
    ],
    "chadian spoken arabic": [
        6855,
        6856
    ],
    "chadic arabic": [
        6855,
        6856
    ],
    "chadic": [
        6855,
        6856
    ],
    "chowa": [
        6855,
        6856
    ],
    "cwaya": [
        6858
    ],
    "chaouia": [
        6860,
        6861,
        6862
    ],
    "chingalese": [
        6864,
        6865
    ],
    "cingalese": [
        6864,
        6865
    ],
    "cebop": [
        6867
    ],
    "chikena": [
        6876
    ],
    "chiquena": [
        6876
    ],
    "chiquiana": [
        6876
    ],
    "cagayan de sulu": [
        6896
    ],
    "cagayanen": [
        6896
    ],
    "cagayanon": [
        6896
    ],
    "calibugan": [
        6923
    ],
    "chisalampasu": [
        6959
    ],
    "chimbari": [
        6964
    ],
    "central sama": [
        6972
    ],
    "central sinama": [
        6972
    ],
    "chishona": [
        6989,
        6990
    ],
    "ceddo": [
        7000,
        7001
    ],
    "cheddo": [
        7000,
        7001
    ],
    "ceona": [
        7004
    ],
    "chango": [
        7008
    ],
    "common somali": [
        7017,
        7018,
        7022
    ],
    "chao song": [
        7023,
        7024
    ],
    "chibne": [
        7041
    ],
    "chibné": [
        7041
    ],
    "caliana": [
        7050
    ],
    "chirichano": [
        7050,
        8642
    ],
    "charapa": [
        7061
    ],
    "castellano sharapa": [
        7061
    ],
    "camerija": [
        7068,
        7070,
        7071
    ],
    "chiranga": [
        7109
    ],
    "cirnga": [
        7109
    ],
    "campidanese": [
        7114
    ],
    "campidanese sardinian": [
        7114
    ],
    "campidese": [
        7114
    ],
    "chee": [
        7115
    ],
    "caw a lalawa": [
        7134
    ],
    "caw": [
        7134
    ],
    "chui-huan": [
        7134
    ],
    "chuihwan": [
        7134
    ],
    "cong": [
        7147,
        7148
    ],
    "cant": [
        7164,
        7710
    ],
    "croato molisano": [
        7220
    ],
    "croato": [
        7220
    ],
    "comorian, maore": [
        7228,
        7229
    ],
    "comorian": [
        7228,
        7229,
        8255,
        8292,
        8293,
        9005,
        9006
    ],
    "comores swahili": [
        7228,
        7229
    ],
    "comores": [
        7228,
        7229
    ],
    "comoro": [
        7228,
        7229
    ],
    "congo swahili": [
        7230,
        7231
    ],
    "chere": [
        7232
    ],
    "coxodoá": [
        7251
    ],
    "central subanen": [
        7267
    ],
    "classical syriac": [
        7268
    ],
    "cachar": [
        7271,
        7272,
        7273
    ],
    "christian neo-aramaic": [
        7275
    ],
    "christian": [
        7275
    ],
    "chaldean": [
        7277
    ],
    "chaldean neo-aramaic": [
        7277
    ],
    "central tarahumara": [
        7318
    ],
    "cumbres": [
        7318
    ],
    "corumbiara": [
        7328
    ],
    "calamian": [
        7338,
        7339
    ],
    "calamian tagbanwa": [
        7338,
        7339
    ],
    "chitembo": [
        7347
    ],
    "chin, tawr": [
        7369
    ],
    "cape york creole": [
        7371
    ],
    "chinatú": [
        7373
    ],
    "chin, thado": [
        7378
    ],
    "chik baraik": [
        7382,
        7383,
        7384
    ],
    "chik": [
        7382,
        7383,
        7384
    ],
    "chik barik": [
        7382,
        7383,
        7384
    ],
    "chinese shan": [
        7386,
        7387
    ],
    "chinese tai": [
        7386,
        7387
    ],
    "caliang": [
        7389
    ],
    "calieng": [
        7389
    ],
    "chueng": [
        7389
    ],
    "charuma": [
        7397
    ],
    "clara": [
        7431
    ],
    "chinsart": [
        7435,
        7436
    ],
    "ciwogai": [
        7449
    ],
    "chalikha": [
        7451
    ],
    "chali": [
        7451
    ],
    "chalipkha": [
        7451
    ],
    "central tagbanwa": [
        7461
    ],
    "carapató": [
        7463
    ],
    "carapoto": [
        7463
    ],
    "central thai": [
        7468,
        7469
    ],
    "chhetriya tharu": [
        7471
    ],
    "chhetriya": [
        7471
    ],
    "chitawan tharu": [
        7471
    ],
    "chitawan": [
        7471
    ],
    "chitoniya tharu": [
        7471
    ],
    "chitoniya": [
        7471
    ],
    "chitwan tharu": [
        7471
    ],
    "chitwan": [
        7471
    ],
    "chitwania tharu": [
        7471
    ],
    "chitwania": [
        7471
    ],
    "chaudary": [
        7476
    ],
    "chaudhuri": [
        7476
    ],
    "chooraroo": [
        7530
    ],
    "choororoo": [
        7530
    ],
    "churoro": [
        7530
    ],
    "chaa wuurong": [
        7531
    ],
    "chaa": [
        7531
    ],
    "chaap wuurong": [
        7531
    ],
    "chaap": [
        7531
    ],
    "chaap-warrong": [
        7531
    ],
    "chaapwurra": [
        7531
    ],
    "chaapwurru": [
        7531
    ],
    "chaapwuurong": [
        7531
    ],
    "chap wurong": [
        7531
    ],
    "chap": [
        7531
    ],
    "chap wurrung": [
        7531
    ],
    "chap-wurong": [
        7531
    ],
    "caxur": [
        7547,
        7548
    ],
    "c’aiχna miz": [
        7547,
        7548
    ],
    "c’aiχna": [
        7547,
        7548
    ],
    "cʼäxna miz": [
        7547,
        7548
    ],
    "cʼäxna": [
        7547,
        7548
    ],
    "cabanatit": [
        7592
    ],
    "citak, tamnim": [
        7600
    ],
    "citak": [
        7600,
        7856
    ],
    "chuana": [
        7613
    ],
    "chwana": [
        7613
    ],
    "coana": [
        7613
    ],
    "cuana": [
        7613
    ],
    "cuwa": [
        7788,
        7618
    ],
    "chieng": [
        7632
    ],
    "chaco sur": [
        7639
    ],
    "chaco": [
        7639
    ],
    "coyutla": [
        7640
    ],
    "coyutla totonac": [
        7640
    ],
    "chitonga": [
        7643,
        7645
    ],
    "chañabal": [
        7646
    ],
    "comiteco": [
        7646
    ],
    "cuoi cham": [
        7654
    ],
    "chhoyul": [
        7674
    ],
    "campuon": [
        7677
    ],
    "celilo": [
        7686
    ],
    "columbia river sahaptin": [
        7686,
        7956
    ],
    "columbia": [
        7686,
        7956,
        8150
    ],
    "cerro": [
        7691
    ],
    "copala": [
        7702
    ],
    "copala trique": [
        7702
    ],
    "copala triqui": [
        7702
    ],
    "copala-trique": [
        7702
    ],
    "chicahuaxtla": [
        7718
    ],
    "chicahuaxtla trique": [
        7718
    ],
    "chicahuaxtla triqui": [
        7718
    ],
    "che-hwan": [
        7722
    ],
    "changana": [
        7727,
        7728
    ],
    "chimmezyan": [
        7737
    ],
    "canglo monba": [
        7738
    ],
    "canglo": [
        7738
    ],
    "cangluo menba": [
        7738
    ],
    "cangluo": [
        7738
    ],
    "cangluo monba": [
        7738
    ],
    "central monpa": [
        7738
    ],
    "cou": [
        7747
    ],
    "central tunebo": [
        7788
    ],
    "cobaría tunebo": [
        7788
    ],
    "cobaría": [
        7788
    ],
    "chitumbuka": [
        7794
    ],
    "citumbuka": [
        7794
    ],
    "curama": [
        7803
    ],
    "cuuramã": [
        7803
    ],
    "cona monba": [
        7828
    ],
    "cona": [
        7828
    ],
    "cuona menba": [
        7828
    ],
    "cuona": [
        7828
    ],
    "cuona monpa": [
        7828
    ],
    "cambap": [
        7829
    ],
    "chiute": [
        7837
    ],
    "ciute": [
        7837
    ],
    "chicao": [
        7846
    ],
    "cicak": [
        7856
    ],
    "cayapo": [
        7857
    ],
    "canga": [
        7862
    ],
    "cenka": [
        7862
    ],
    "changa": [
        7862
    ],
    "coo-coo-warra": [
        7869
    ],
    "cancuc": [
        7880
    ],
    "chanal": [
        7880
    ],
    "central atlas tamazight": [
        7884,
        7885,
        7886
    ],
    "central shilha": [
        7884,
        7885,
        7886
    ],
    "carranza": [
        7888,
        7889,
        7890,
        7891
    ],
    "cunni": [
        7975
    ],
    "colh": [
        7976,
        7977,
        7978,
        7979
    ],
    "cimarrón": [
        7992
    ],
    "caapor": [
        7993
    ],
    "chaw talay": [
        8000
    ],
    "chaw": [
        8000
    ],
    "colorado river numic": [
        8023
    ],
    "cevenda": [
        8067,
        8068
    ],
    "chivenda": [
        8067,
        8068
    ],
    "chipileño": [
        8069
    ],
    "chividunda": [
        8082
    ],
    "civili": [
        8083
    ],
    "creole portuguese": [
        8097,
        8098
    ],
    "central juxtlahuaca mixtec": [
        8106
    ],
    "chirima": [
        8114
    ],
    "chico": [
        8122
    ],
    "chico maidu": [
        8122
    ],
    "central makhuwa": [
        8123,
        8124
    ],
    "comunitat": [
        8141
    ],
    "columbia chinook": [
        8150
    ],
    "chasi": [
        8181
    ],
    "central waica": [
        8194
    ],
    "cpe": [
        8212
    ],
    "cameroon creole": [
        8212
    ],
    "cameroon creole english": [
        8212
    ],
    "cameroon pidgin": [
        8212
    ],
    "cameroonian creole": [
        8212
    ],
    "cameroonian": [
        8212
    ],
    "cos": [
        8212
    ],
    "chin, rawngtu": [
        8214
    ],
    "comorian, mwali": [
        8255
    ],
    "caurasia": [
        8275
    ],
    "chaurasia": [
        8275
    ],
    "chaurasya": [
        8275
    ],
    "chourase": [
        8275
    ],
    "chourasia": [
        8275
    ],
    "chalgari": [
        8290
    ],
    "comorian, ndzwani": [
        8292,
        8293
    ],
    "chɨwʉngʉ": [
        8366
    ],
    "chinese, wu": [
        8369,
        8370,
        8371
    ],
    "cachari": [
        8391
    ],
    "caimbé": [
        8395
    ],
    "cambe": [
        8395
    ],
    "catauichi": [
        8407
    ],
    "catauixi": [
        8407
    ],
    "catawishi": [
        8407
    ],
    "catawixi": [
        8407
    ],
    "crisca": [
        8409
    ],
    "cambioá": [
        8425
    ],
    "cambiuá": [
        8425
    ],
    "cumbric": [
        8427
    ],
    "camunic": [
        8428
    ],
    "celtiberian": [
        8429
    ],
    "cisalpine gaulish": [
        8430
    ],
    "cisalpine": [
        8430
    ],
    "chemakum": [
        8431
    ],
    "chimakum": [
        8431
    ],
    "classical armenian": [
        8432
    ],
    "comecrudo": [
        8433
    ],
    "cotoname": [
        8434
    ],
    "chorasmian": [
        8435,
        8436
    ],
    "carian": [
        8437
    ],
    "classical tibetan": [
        8438
    ],
    "curonian": [
        8439
    ],
    "chuvantsy": [
        8440
    ],
    "coahuilteco": [
        8441
    ],
    "cayuse": [
        8442
    ],
    "cheta": [
        8458
    ],
    "curutón": [
        8458
    ],
    "corine": [
        8465
    ],
    "coro-ran": [
        8465
    ],
    "charumbul": [
        8468
    ],
    "coa": [
        8471
    ],
    "coah": [
        8471
    ],
    "cape hottentot": [
        8483
    ],
    "complex": [
        8485
    ],
    "chiriana": [
        8486
    ],
    "chiriána": [
        8486
    ],
    "cood-jingburra": [
        8490
    ],
    "cudgingberry": [
        8490
    ],
    "chakriaba": [
        8507
    ],
    "chicriaba": [
        8507
    ],
    "chicriabá": [
        8507
    ],
    "chikriaba": [
        8507
    ],
    "cuneiform luwian": [
        8528
    ],
    "cuneiform": [
        8528
    ],
    "coastal makhuwa": [
        8532
    ],
    "currak-da-bidgee": [
        8560
    ],
    "chingoni": [
        8561
    ],
    "catarina": [
        9164,
        8579,
        9161
    ],
    "central koma": [
        8580
    ],
    "caceteiros": [
        8586
    ],
    "culina pano": [
        8597
    ],
    "capinauá": [
        8600
    ],
    "craho": [
        8615
    ],
    "craô": [
        8615
    ],
    "cundunorah": [
        8617
    ],
    "crange": [
        8618
    ],
    "crenge": [
        8618
    ],
    "crenye": [
        8618
    ],
    "creye": [
        8618
    ],
    "caura": [
        8642
    ],
    "chazumba": [
        8646
    ],
    "chazumba mixtec": [
        8646
    ],
    "central nochistlán mixtec": [
        8648
    ],
    "cuyamecalco": [
        8664
    ],
    "cuicatlán mixtec": [
        8664
    ],
    "cuicatlán": [
        8664
    ],
    "cuyamecalco mixtec": [
        8664
    ],
    "cañada": [
        8664
    ],
    "cazama": [
        8684
    ],
    "coaiá": [
        8690
    ],
    "coropó": [
        8705
    ],
    "chichawa": [
        8733,
        8734
    ],
    "chiyao": [
        8733,
        8734
    ],
    "chiyawo": [
        8733,
        8734
    ],
    "ciyaawo": [
        8733,
        8734
    ],
    "ciyao": [
        8733,
        8734
    ],
    "ciyawo": [
        8733,
        8734
    ],
    "cahita": [
        8736
    ],
    "chicano": [
        8740
    ],
    "chikano": [
        8740
    ],
    "ceya": [
        8750
    ],
    "chesu": [
        8760
    ],
    "central yi": [
        8761
    ],
    "chepya": [
        8763
    ],
    "ciyei": [
        8780
    ],
    "conehead phula": [
        8792
    ],
    "conehead": [
        8792
    ],
    "camuchivo": [
        8842
    ],
    "chimaraba": [
        8846,
        8847
    ],
    "ciyoombe": [
        8878
    ],
    "coastal tupian": [
        8896
    ],
    "chinese, yue": [
        8923,
        8924,
        8925,
        8926
    ],
    "cantonese": [
        8923,
        8924,
        8925,
        8926
    ],
    "chinese nung": [
        8923,
        8924,
        8925,
        8926
    ],
    "carib motilón": [
        8935
    ],
    "chillula": [
        8937
    ],
    "central lalo": [
        8952
    ],
    "cateebil": [
        8956
    ],
    "cajonos": [
        8972
    ],
    "cajonos zapotec": [
        8972
    ],
    "chaan": [
        8983
    ],
    "central villa alta zapotec": [
        8988
    ],
    "central berawan": [
        8997
    ],
    "coatecas": [
        9003
    ],
    "coatecas altas zapotec": [
        9003
    ],
    "central hongshuihe zhuang": [
        9004
    ],
    "comorian, ngazidja": [
        9005,
        9006
    ],
    "chinese, mandarin": [
        9021,
        9020,
        9022,
        9030,
        9040
    ],
    "chinese (family)": [
        9050
    ],
    "chizigula": [
        9057
    ],
    "charumba": [
        9068
    ],
    "coorna": [
        9071
    ],
    "colloquial malay": [
        9077,
        9078
    ],
    "copainalá": [
        9113
    ],
    "copainalá zoque": [
        9113
    ],
    "chimalapa": [
        9114
    ],
    "chimalapa zoque": [
        9114
    ],
    "choapan": [
        9122
    ],
    "choapan zapotec": [
        9122
    ],
    "cristóbal": [
        9134
    ],
    "coatlán zapotec": [
        9138,
        9139
    ],
    "chichicapan": [
        9141
    ],
    "chichicapan zapotec": [
        9141
    ],
    "central sola de vega zapotec": [
        9145
    ],
    "chaari": [
        9174
    ],
    "content": [
        9180
    ],
    "caj coux": [
        9181
    ],
    "caj": [
        9181
    ],
    "coux": [
        9181
    ],
    "can yang": [
        9181
    ],
    "can": [
        9181
    ],
    "chin, zyphe": [
        9185
    ],
    "canto": [
        9188
    ]
};
